/*
 * Currency tools
 *
 * Copyright (c) 2015 Caroline Schnapp (mllegeorgesand@gmail.com)
 * Licensed under the MIT license:
 * http://www.opensource.org/licenses/mit-license.php
 *
 */

if(typeof Currency==="undefined"){var Currency={}}Currency.cookie={configuration:{expires:365,path:"/",domain:window.location.hostname},name:"currency",write:function(a){jQuery.cookie(this.name,a,this.configuration)},read:function(){return jQuery.cookie(this.name)},destroy:function(){jQuery.cookie(this.name,null,this.configuration)}};Currency.moneyFormats={USD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} USD"},EUR:{money_format:"&euro;{{amount}}",money_with_currency_format:"&euro;{{amount}} EUR"},GBP:{money_format:"&pound;{{amount}}",money_with_currency_format:"&pound;{{amount}} GBP"},CAD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} CAD"},ALL:{money_format:"Lek {{amount}}",money_with_currency_format:"Lek {{amount}} ALL"},DZD:{money_format:"DA {{amount}}",money_with_currency_format:"DA {{amount}} DZD"},AOA:{money_format:"Kz{{amount}}",money_with_currency_format:"Kz{{amount}} AOA"},ARS:{money_format:"${{amount_with_comma_separator}}",money_with_currency_format:"${{amount_with_comma_separator}} ARS"},AMD:{money_format:"{{amount}} AMD",money_with_currency_format:"{{amount}} AMD"},AWG:{money_format:"Afl{{amount}}",money_with_currency_format:"Afl{{amount}} AWG"},AUD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} AUD"},BBD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} Bds"},AZN:{money_format:"m.{{amount}}",money_with_currency_format:"m.{{amount}} AZN"},BDT:{money_format:"Tk {{amount}}",money_with_currency_format:"Tk {{amount}} BDT"},BSD:{money_format:"BS${{amount}}",money_with_currency_format:"BS${{amount}} BSD"},BHD:{money_format:"{{amount}}0 BD",money_with_currency_format:"{{amount}}0 BHD"},BYR:{money_format:"Br {{amount}}",money_with_currency_format:"Br {{amount}} BYR"},BZD:{money_format:"BZ${{amount}}",money_with_currency_format:"BZ${{amount}} BZD"},BTN:{money_format:"Nu {{amount}}",money_with_currency_format:"Nu {{amount}} BTN"},BAM:{money_format:"KM {{amount_with_comma_separator}}",money_with_currency_format:"KM {{amount_with_comma_separator}} BAM"},BRL:{money_format:"R$ {{amount_with_comma_separator}}",money_with_currency_format:"R$ {{amount_with_comma_separator}} BRL"},BOB:{money_format:"Bs{{amount_with_comma_separator}}",money_with_currency_format:"Bs{{amount_with_comma_separator}} BOB"},BWP:{money_format:"P{{amount}}",money_with_currency_format:"P{{amount}} BWP"},BND:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} BND"},BGN:{money_format:"{{amount}} лв",money_with_currency_format:"{{amount}} лв BGN"},MMK:{money_format:"K{{amount}}",money_with_currency_format:"K{{amount}} MMK"},KHR:{money_format:"KHR{{amount}}",money_with_currency_format:"KHR{{amount}}"},KYD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} KYD"},XAF:{money_format:"FCFA{{amount}}",money_with_currency_format:"FCFA{{amount}} XAF"},CLP:{money_format:"${{amount_no_decimals}}",money_with_currency_format:"${{amount_no_decimals}} CLP"},CNY:{money_format:"&#165;{{amount}}",money_with_currency_format:"&#165;{{amount}} CNY"},COP:{money_format:"${{amount_with_comma_separator}}",money_with_currency_format:"${{amount_with_comma_separator}} COP"},CRC:{money_format:"&#8353; {{amount_with_comma_separator}}",money_with_currency_format:"&#8353; {{amount_with_comma_separator}} CRC"},HRK:{money_format:"{{amount_with_comma_separator}} kn",money_with_currency_format:"{{amount_with_comma_separator}} kn HRK"},CZK:{money_format:"{{amount_with_comma_separator}} K&#269;",money_with_currency_format:"{{amount_with_comma_separator}} K&#269;"},DKK:{money_format:"{{amount_with_comma_separator}}",money_with_currency_format:"kr.{{amount_with_comma_separator}}"},DOP:{money_format:"RD$ {{amount}}",money_with_currency_format:"RD$ {{amount}}"},XCD:{money_format:"${{amount}}",money_with_currency_format:"EC${{amount}}"},EGP:{money_format:"LE {{amount}}",money_with_currency_format:"LE {{amount}} EGP"},ETB:{money_format:"Br{{amount}}",money_with_currency_format:"Br{{amount}} ETB"},XPF:{money_format:"{{amount_no_decimals_with_comma_separator}} XPF",money_with_currency_format:"{{amount_no_decimals_with_comma_separator}} XPF"},FJD:{money_format:"${{amount}}",money_with_currency_format:"FJ${{amount}}"},GMD:{money_format:"D {{amount}}",money_with_currency_format:"D {{amount}} GMD"},GHS:{money_format:"GH&#8373;{{amount}}",money_with_currency_format:"GH&#8373;{{amount}}"},GTQ:{money_format:"Q{{amount}}",money_with_currency_format:"{{amount}} GTQ"},GYD:{money_format:"G${{amount}}",money_with_currency_format:"${{amount}} GYD"},GEL:{money_format:"{{amount}} GEL",money_with_currency_format:"{{amount}} GEL"},HNL:{money_format:"L {{amount}}",money_with_currency_format:"L {{amount}} HNL"},HKD:{money_format:"${{amount}}",money_with_currency_format:"HK${{amount}}"},HUF:{money_format:"{{amount_no_decimals_with_comma_separator}}",money_with_currency_format:"{{amount_no_decimals_with_comma_separator}} Ft"},ISK:{money_format:"{{amount_no_decimals}} kr",money_with_currency_format:"{{amount_no_decimals}} kr ISK"},INR:{money_format:"Rs. {{amount}}",money_with_currency_format:"Rs. {{amount}}"},IDR:{money_format:"{{amount_with_comma_separator}}",money_with_currency_format:"Rp {{amount_with_comma_separator}}"},ILS:{money_format:"{{amount}} NIS",money_with_currency_format:"{{amount}} NIS"},JMD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} JMD"},JPY:{money_format:"&#165;{{amount_no_decimals}}",money_with_currency_format:"&#165;{{amount_no_decimals}} JPY"},JEP:{money_format:"&pound;{{amount}}",money_with_currency_format:"&pound;{{amount}} JEP"},JOD:{money_format:"{{amount}}0 JD",money_with_currency_format:"{{amount}}0 JOD"},KZT:{money_format:"{{amount}} KZT",money_with_currency_format:"{{amount}} KZT"},KES:{money_format:"KSh{{amount}}",money_with_currency_format:"KSh{{amount}}"},KWD:{money_format:"{{amount}}0 KD",money_with_currency_format:"{{amount}}0 KWD"},KGS:{money_format:"лв{{amount}}",money_with_currency_format:"лв{{amount}}"},LVL:{money_format:"Ls {{amount}}",money_with_currency_format:"Ls {{amount}} LVL"},LBP:{money_format:"L&pound;{{amount}}",money_with_currency_format:"L&pound;{{amount}} LBP"},LTL:{money_format:"{{amount}} Lt",money_with_currency_format:"{{amount}} Lt"},MGA:{money_format:"Ar {{amount}}",money_with_currency_format:"Ar {{amount}} MGA"},MKD:{money_format:"ден {{amount}}",money_with_currency_format:"ден {{amount}} MKD"},MOP:{money_format:"MOP${{amount}}",money_with_currency_format:"MOP${{amount}}"},MVR:{money_format:"Rf{{amount}}",money_with_currency_format:"Rf{{amount}} MRf"},MXN:{money_format:"$ {{amount}}",money_with_currency_format:"$ {{amount}} MXN"},MYR:{money_format:"RM{{amount}} MYR",money_with_currency_format:"RM{{amount}} MYR"},MUR:{money_format:"Rs {{amount}}",money_with_currency_format:"Rs {{amount}} MUR"},MDL:{money_format:"{{amount}} MDL",money_with_currency_format:"{{amount}} MDL"},MAD:{money_format:"{{amount}} dh",money_with_currency_format:"Dh {{amount}} MAD"},MNT:{money_format:"{{amount_no_decimals}} &#8366",money_with_currency_format:"{{amount_no_decimals}} MNT"},MZN:{money_format:"{{amount}} Mt",money_with_currency_format:"Mt {{amount}} MZN"},NAD:{money_format:"N${{amount}}",money_with_currency_format:"N${{amount}} NAD"},NPR:{money_format:"Rs{{amount}}",money_with_currency_format:"Rs{{amount}} NPR"},ANG:{money_format:"&fnof;{{amount}}",money_with_currency_format:"{{amount}} NA&fnof;"},NZD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} NZD"},NIO:{money_format:"C${{amount}}",money_with_currency_format:"C${{amount}} NIO"},NGN:{money_format:"&#8358;{{amount}}",money_with_currency_format:"&#8358;{{amount}} NGN"},NOK:{money_format:"kr {{amount_with_comma_separator}}",money_with_currency_format:"kr {{amount_with_comma_separator}} NOK"},OMR:{money_format:"{{amount_with_comma_separator}} OMR",money_with_currency_format:"{{amount_with_comma_separator}} OMR"},PKR:{money_format:"Rs.{{amount}}",money_with_currency_format:"Rs.{{amount}} PKR"},PGK:{money_format:"K {{amount}}",money_with_currency_format:"K {{amount}} PGK"},PYG:{money_format:"Gs. {{amount_no_decimals_with_comma_separator}}",money_with_currency_format:"Gs. {{amount_no_decimals_with_comma_separator}} PYG"},PEN:{money_format:"S/. {{amount}}",money_with_currency_format:"S/. {{amount}} PEN"},PHP:{money_format:"&#8369;{{amount}}",money_with_currency_format:"&#8369;{{amount}} PHP"},PLN:{money_format:"{{amount_with_comma_separator}} zl",money_with_currency_format:"{{amount_with_comma_separator}} zl PLN"},QAR:{money_format:"QAR {{amount_with_comma_separator}}",money_with_currency_format:"QAR {{amount_with_comma_separator}}"},RON:{money_format:"{{amount_with_comma_separator}} lei",money_with_currency_format:"{{amount_with_comma_separator}} lei RON"},RUB:{money_format:"&#1088;&#1091;&#1073;{{amount_with_comma_separator}}",money_with_currency_format:"&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB"},RWF:{money_format:"{{amount_no_decimals}} RF",money_with_currency_format:"{{amount_no_decimals}} RWF"},WST:{money_format:"WS$ {{amount}}",money_with_currency_format:"WS$ {{amount}} WST"},SAR:{money_format:"{{amount}} SR",money_with_currency_format:"{{amount}} SAR"},STD:{money_format:"Db {{amount}}",money_with_currency_format:"Db {{amount}} STD"},RSD:{money_format:"{{amount}} RSD",money_with_currency_format:"{{amount}} RSD"},SCR:{money_format:"Rs {{amount}}",money_with_currency_format:"Rs {{amount}} SCR"},SGD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} SGD"},SYP:{money_format:"S&pound;{{amount}}",money_with_currency_format:"S&pound;{{amount}} SYP"},ZAR:{money_format:"R {{amount}}",money_with_currency_format:"R {{amount}} ZAR"},KRW:{money_format:"&#8361;{{amount_no_decimals}}",money_with_currency_format:"&#8361;{{amount_no_decimals}} KRW"},LKR:{money_format:"Rs {{amount}}",money_with_currency_format:"Rs {{amount}} LKR"},SEK:{money_format:"{{amount_no_decimals}} kr",money_with_currency_format:"{{amount_no_decimals}} kr SEK"},CHF:{money_format:"SFr. {{amount}}",money_with_currency_format:"SFr. {{amount}} CHF"},TWD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} TWD"},THB:{money_format:"{{amount}} &#xe3f;",money_with_currency_format:"{{amount}} &#xe3f; THB"},TZS:{money_format:"{{amount}} TZS",money_with_currency_format:"{{amount}} TZS"},TTD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} TTD"},TND:{money_format:"{{amount}}",money_with_currency_format:"{{amount}} DT"},TRY:{money_format:"{{amount}}TL",money_with_currency_format:"{{amount}}TL"},UGX:{money_format:"Ush {{amount_no_decimals}}",money_with_currency_format:"Ush {{amount_no_decimals}} UGX"},UAH:{money_format:"₴{{amount}}",money_with_currency_format:"₴{{amount}} UAH"},AED:{money_format:"Dhs. {{amount}}",money_with_currency_format:"Dhs. {{amount}} AED"},UYU:{money_format:"${{amount_with_comma_separator}}",money_with_currency_format:"${{amount_with_comma_separator}} UYU"},VUV:{money_format:"${{amount}}",money_with_currency_format:"${{amount}}VT"},VEF:{money_format:"Bs. {{amount_with_comma_separator}}",money_with_currency_format:"Bs. {{amount_with_comma_separator}} VEF"},VND:{money_format:"{{amount_no_decimals_with_comma_separator}}&#8363;",money_with_currency_format:"{{amount_no_decimals_with_comma_separator}} VND"},XBT:{money_format:"{{amount_no_decimals}} BTC",money_with_currency_format:"{{amount_no_decimals}} BTC"},XOF:{money_format:"CFA{{amount}}",money_with_currency_format:"CFA{{amount}} XOF"},ZMW:{money_format:"K{{amount_no_decimals_with_comma_separator}}",money_with_currency_format:"ZMW{{amount_no_decimals_with_comma_separator}}"}};Currency.formatMoney=function(b,g){if(typeof Shopify.formatMoney==="function"){return Shopify.formatMoney(b,g)}if(typeof b=="string"){b=b.replace(".","")}var f="";var e=/\{\{\s*(\w+)\s*\}\}/;var a=g||"${{amount}}";function c(h,i){return(typeof h=="undefined"?i:h)}function d(m,k,l,j){k=c(k,2);l=c(l,",");j=c(j,".");if(isNaN(m)||m==null){return 0}m=(m/100).toFixed(k);var n=m.split("."),i=n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+l),h=n[1]?(j+n[1]):"";return i+h}switch(a.match(e)[1]){case"amount":f=d(b,2);break;case"amount_no_decimals":f=d(b,0);break;case"amount_with_comma_separator":f=d(b,2,".",",");break;case"amount_no_decimals_with_comma_separator":f=d(b,0,".",",");break}return a.replace(e,f)};Currency.currentCurrency="";Currency.format="money_with_currency_format";Currency.convertAll=function(c,b,a,d){jQuery(a||"span.money").each(function(){if(jQuery(this).attr("data-currency")===b){return}if(jQuery(this).attr("data-currency-"+b)){jQuery(this).html(jQuery(this).attr("data-currency-"+b))}else{var e=0;var f=Currency.moneyFormats[c][d||Currency.format]||"{{amount}}";var g=Currency.moneyFormats[b][d||Currency.format]||"{{amount}}";if(f.indexOf("amount_no_decimals")!==-1){e=Currency.convert(parseInt(jQuery(this).html().replace(/[^0-9]/g,""),10)*100,c,b)}else{if(c==="JOD"||c=="KWD"||c=="BHD"){e=Currency.convert(parseInt(jQuery(this).html().replace(/[^0-9]/g,""),10)/10,c,b)}else{e=Currency.convert(parseInt(jQuery(this).html().replace(/[^0-9]/g,""),10),c,b)}}var h=Currency.formatMoney(e,g);jQuery(this).html(h);jQuery(this).attr("data-currency-"+b,h)}jQuery(this).attr("data-currency",b)});this.currentCurrency=b;this.cookie.write(b)};


Object.defineProperty(HTMLMediaElement.prototype, 'isPlaying', {
  get: function() {
    return !!(
      this.currentTime > 0 &&
      !this.paused &&
      !this.ended &&
      this.readyState > 2
    )
  },
})

window.theme = window.theme || {}

/* ================ SLATE ================ */
window.theme = window.theme || {}

theme.Sections = function Sections() {
  this.constructors = {}
  this.instances = []

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this))
}

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container)
    var id = $container.attr('data-section-id')
    var type = $container.attr('data-section-type')

    constructor = constructor || this.constructors[type]

    if (_.isUndefined(constructor)) {
      return
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container,
    })

    this.instances.push(instance)
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0]
    if (container) {
      this._createInstance(container)
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = instance.id === evt.detail.sectionId

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt)
        }
      }

      return !isEventInstance
    })
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId
    })

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt)
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId
    })

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt)
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId
    })

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt)
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId
    })

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt)
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor

    $('[data-section-type=' + type + ']').each(
      function(index, container) {
        this._createInstance(container, constructor)
      }.bind(this)
    )
  },
})

window.slate = window.slate || {}

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    options.$tables.wrap(
      '<div class="' + options.tableWrapperClass + '"></div>'
    )
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + options.iframeWrapperClass + '"></div>')

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src
    })
  },
}

window.slate = window.slate || {}

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden'

    $element
      .first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback)

    function callback() {
      $element
        .first()
        .removeClass(focusClass)
        .removeAttr('tabindex')
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash))
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on(
      'click',
      function(evt) {
        this.pageLinkFocus($(evt.currentTarget.hash))
      }.bind(this)
    )
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin'

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container
    }

    options.$container.attr('tabindex', '-1')
    options.$elementToFocus.focus()

    $(document).off('focusin')

    $(document).on(eventName, function(evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus()
      }
    })
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin'

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex')
    }

    $(document).off(eventName)
  },
}

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Utils = {}

theme.Utils.element = function(type, props, children) {
  var properties = Object.keys(props).reduce(function(a, key) {
    return a + ' ' + key + '="' + props[key] + '"'
  }, '')

  return '<' + type + ' ' + properties + '> ' + children + ' </' + type + '>'
}

theme.Utils.slideArrow = function(dir) {
  return dir === 'next' || dir === 'right'
    ? theme.Utils.element(
        'button',
        { class: 's-slick-next s-slick-arrow' },
        theme.assets.chevronRight
      )
    : theme.Utils.element(
        'button',
        { class: 's-slick-prev s-slick-arrow' },
        theme.assets.chevronLeft
      )
}

theme.Images = (function() {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images]
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i]
      this.loadImage(this.getSizedImageUrl(image, size))
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src)
    var imageUrl = this.getSizedImageUrl(image.src, size)

    if (callback) {
      callback(imageUrl, image, element) // eslint-disable-line callback-return
    } else {
      element.src = imageUrl
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/
    )

    if (match !== null) {
      if (match[2] !== undefined) {
        return match[1] + match[2]
      } else {
        return match[1]
      }
    } else {
      return null
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src
    }

    if (size === 'master') {
      return this.removeProtocol(src)
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    )

    if (match !== null) {
      var prefix = src.split(match[0])
      var suffix = match[0]

      return this.removeProtocol(prefix[0] + '_' + size + suffix)
    }

    return null
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '')
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol,
  }
})()

// Waypoint
theme.WaypointFactory = function($el, offset) {
  offset = parseInt(offset, 10) || 0
  var el = $el[0]
  var rect = el.getBoundingClientRect()
  var wHeight = window.innerHeight

  /**
   * Returns true if:
   * 1. Top edge of element is below top of viewport
   * 2. Bottom edge of element is above bottom of viewport
   */
  var isVisible = function() {
    return rect.top >= 0 && rect.bottom <= wHeight + offset
  }

  /**
   * Returns...
   * 1. 'bottom' if bottom edge is greater than viewport
   * 2. 'top' if top edge is less than viewport
   * 3. 'inside' otherwise
   */
  var location = function() {
    if (rect.bottom >= wHeight + offset) return 'bottom'
    else if (rect.top <= 0) return 'top'
    return 'inside'
  }

  return {
    isVisible: isVisible(),
    location: location(),
    rect: rect,
  }
}

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function() {
  var moneyFormat = '${{amount}}' // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '')
    }
    var value = ''
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
    var formatString = format || moneyFormat

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ','
      decimal = decimal || '.'

      if (isNaN(number) || number === null) {
        return 0
      }

      number = (number / 100.0).toFixed(precision)

      var parts = number.split('.')
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      )
      var centsAmount = parts[1] ? decimal + parts[1] : ''

      return dollarsAmount + centsAmount
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2)
        break
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0)
        break
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',')
        break
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',')
        break
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ')
        break
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'")
        break
    }

    return formatString.replace(placeholderRegex, value)
  }

  return {
    formatMoney: formatMoney,
  }
})()

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container
    this.product = options.product
    this.singleOptionSelector = options.singleOptionSelector
    this.originalSelectorId = options.originalSelectorId
    this.enableHistoryState = options.enableHistoryState
    this.currentVariant = this._getVariantFromOptions()

    $(this.singleOptionSelector, this.$container).on(
      'change',
      this._onSelectChange.bind(this)
    )
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = _.map(
        $(this.singleOptionSelector, this.$container),
        function(element) {
          var $element = $(element)
          var type = $element.attr('type')
          var currentOption = {}

          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              currentOption.value = $element.val()
              currentOption.index = $element.data('index')

              return currentOption
            } else {
              return false
            }
          } else {
            currentOption.value = $element.val()
            currentOption.index = $element.data('index')

            return currentOption
          }
        }
      )

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions)

      return currentOptions
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions()
      var variants = this.product.variants

      var found = _.find(variants, function(variant) {
        return selectedValues.every(function(values) {
          return _.isEqual(variant[values.index], values.value)
        })
      })

      return found
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions()

      this.$container.trigger({
        type: 'variantChange',
        variant: variant,
      })

      if (!variant) {
        return
      }

      this._updateMasterSelect(variant)
      this._updateImages(variant)
      this._updatePrice(variant)
      this._updateSKU(variant)
      this.currentVariant = variant

      if (this.enableHistoryState) {
        this._updateHistoryState(variant)
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {}
      var currentVariantImage = this.currentVariant.featured_image || {}

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant,
      })
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant,
      })
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant,
      })
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return
      }

      var newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        '?variant=' +
        variant.id
      window.history.replaceState({ path: newurl }, '', newurl)
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container).val(variant.id)
    },
  })

  return Variants
})()

/* ================ GLOBAL ================ */

/**
 * Returns Sticker class
 * @return {Function} - Sticker class
 */
theme.Sticker = (function() {
  /**
   * Make things sticky
   * @constructor
   * @param {String} opts.waypoint     -  Selector for a waypoint element to determine stop point
   * @param {String} opts.stickElement -  Selector for element to apply sticky rules
   * @param {String} opts.stickParent  -  Selector for sticky's parent element. (default: opts.stickElement.parent())
   * @param {Number} opts.scrollOffset -  Changes location of trigger point (default: 0)
   * @return {Object}
   */
  function Sticker(opts) {
    this.opts = opts
    this.state = {
      waypoint: {}, // { isVisible: {Boolean}, location: {String}, rect: {DOMRect} }
      contentRect: {}, // instance of DOMRect
      parentRect: {}, // instance of DOMRect
      offset: {
        top: 0,
        bot: 0,
        wp: 0,
      },
      scrollTop: 0,
      scrollOffset: 0,
      css: {},
    }

    this.cache = {
      $waypoint: $(opts.waypoint),
      $stickElement: $(opts.stickElement),
      $stickParent: $(opts.stickParent),
      $window: $(window),
      $mainContainer: $(opts.mainContainer),
    }

    // Find a parent for our sticky element
    if (!this.cache.$stickParent.length) {
      this.cache.$stickParent = this.cache.$stickElement.parent()
    }

    if (!this.cache.$mainContainer.length) {
      this.cache.$mainContainer = this.cache.$stickParent
    }

    // Add position relative to parent
    this.cache.$stickParent.css({ position: 'relative' })
  }

  Sticker.prototype.getScrollOffset = function() {
    return typeof this.opts.scrollOffset === 'function'
      ? this.opts.scrollOffset() || 0
      : this.opts.scrollOffset || 0
  }

  Sticker.prototype.fixed = function() {
    return {
      position: 'fixed',
      width: this.state.parentRect.width + 'px',
      bottom: '',
      top: this.state.offset.top + 'px',
    }
  }

  Sticker.prototype.absolute = function() {
    return {
      position: 'absolute',
      width: this.state.parentRect.width + 'px',
      bottom: this.state.offset.bot + 'px',
      top: '',
    }
  }

  Sticker.prototype.unset = function() {
    return {
      position: '',
      width: '',
      bottom: '',
      top: '',
    }
  }

  Sticker.prototype.stick = function() {
    this.setState()
    this.setPosition()
    this.cache.$window
      .on('DOMContentLoaded load resize', this.setState.bind(this))
      .on('scroll touchmove resize', this.setPosition.bind(this))
  }

  Sticker.prototype.unstick = function() {
    this.cache.$window.off('DOMContentLoaded load resize scroll touchmove')
    this.cache.$stickElement.css(this.unset())
  }

  Sticker.prototype.setState = function() {
    this.state.scrollOffset = this.getScrollOffset()
    this.state.contentRect = this.cache.$stickElement[0].getBoundingClientRect()
    this.state.parentRect = this.cache.$stickParent[0].getBoundingClientRect()
    this.state.scrollTop =
      this.cache.$window[0].scrollY || this.cache.$window[0].pageYOffset

    // Start offset - Distance between top of sticky element and top of window (minus scroll offset)
    this.state.offset.top =
      this.state.scrollTop + this.state.parentRect.top - this.state.scrollOffset

    // Stop offset - Distance between bottom of sticky element and bottom of viewport height (this is scroll offset for stop)
    this.state.offset.wp =
      this.state.contentRect.height + this.state.offset.top - window.innerHeight

    // Establish waypoint with offset
    this.state.waypoint = theme.WaypointFactory(
      this.cache.$waypoint,
      this.state.offset.wp
    )

    // Bottom offset - Distance between top edge of parent and top edge of offsetted WP
    this.state.offset.bot =
      this.cache.$stickParent[0].getBoundingClientRect().top -
      this.state.waypoint.rect.top
  }

  Sticker.prototype.setPosition = function() {
    this.state.waypoint = theme.WaypointFactory(
      this.cache.$waypoint,
      this.state.offset.wp
    )
    this.state.scrollTop =
      this.cache.$window[0].scrollY || this.cache.$window[0].pageYOffset
    var isWpBot = this.state.waypoint.location === 'bottom'

    /**
     * True if we scrolled past our start offset
     * @type {Boolean}
     */
    var isOffsetAbove = this.state.scrollTop >= this.state.scrollOffset

    /**
     * True if stop and start points are below OR height extends past waypoint
     * @type {Boolean}
     */
    var shouldUnset =
      (isWpBot && !isOffsetAbove) ||
      this.state.contentRect.height +
        this.state.offset.top +
        this.state.scrollOffset >=
        this.state.waypoint.rect.top + this.state.scrollTop

    /**
     * True if stop point is below, and start point is above
     * @type {Boolean}
     */
    var shouldFix = isWpBot && isOffsetAbove

    var css = this.absolute()
    if (shouldUnset) {
      css = this.unset()
    }

    if (shouldFix) {
      css = this.fixed()
    }

    if (!_.isEqual(this.state.css, css)) {
      this.state.css = css
      this.cache.$stickElement.css(this.state.css)
    }
  }

  return Sticker
})()

// Countdown
theme.Countdown = (function() {
  function Countdown(container, noSubscribe) {
    var self = this
    this.tz = theme.strings.tz
    this.cache = {}
    this.workers = []
    this.cache.$container = $(container)
    this.cache.$timers = this.cache.$container.find('.js-countdown')
    this.cache.$timers.each(function() {
      var worker = self.letsParty.call(self, $(this))
      if (!noSubscribe) {
        worker.subscribe()
      }

      self.workers.push(worker)
    })
  }

  Countdown.pad = function(x) {
    var strX = String(x)

    if (strX.length >= 2) {
      return strX
    }

    return ('0' + x).substring(strX.length - 1)
  }

  Countdown.prototype.letsParty = function(el) {
    var interval
    var $this = $(el)
    var end = $this.data('end')
    var start = $this.data('start')
    var momentStart = moment.unix(start).tz(this.tz)
    var momentEnd = moment.unix(end).tz(this.tz)

    function getRelativeDt() {
      var momentNow = moment(new Date()).tz(this.tz)
      var diffStart = momentStart.diff(momentNow)
      var diffEnd = momentEnd.diff(momentNow)
      var momentDuration = moment.duration(diffEnd)
      var DD =
        momentDuration.days() +
        moment.duration(momentDuration.years(), 'years').asDays()
      var HH = momentDuration.hours()
      var mm = momentDuration.minutes()
      var ss = momentDuration.seconds()

      return {
        diffStart: diffStart,
        diffEnd: diffEnd,
        DD: DD,
        HH: HH,
        mm: mm,
        ss: ss,
      }
    }

    function renderTime() {
      var displayer = $this.find('.js-countdown-display')
      var waitText = $this.data('attr1')
      var closeText = $this.data('attr2')
      var relativeDt = getRelativeDt()

      if (relativeDt.diffStart > 0) {
        var m = momentStart.format('MMMM Do YYYY, h:mm a zz')
        return displayer.text(waitText + ' ' + m)
      }

      if (relativeDt.diffEnd <= 0) {
        window.clearInterval(interval)
        return displayer.text(closeText)
      }

      var dt =
        Countdown.pad(relativeDt.DD) +
        ' : ' +
        Countdown.pad(relativeDt.HH) +
        ' : ' +
        Countdown.pad(relativeDt.mm) +
        ' : ' +
        Countdown.pad(relativeDt.ss)

      return displayer.text(dt)
    }

    function subscribe() {
      interval = window.setInterval(renderTime, 1000)
    }

    function unsubscribe() {
      window.clearInterval(interval)
    }

    return {
      getRelativeDt: getRelativeDt,
      subscribe: subscribe,
      unsubscribe: unsubscribe,
    }
  }

  return Countdown
})()

// Mobile slider
theme.MobileSlider = (function() {
  function MobileSlider(container) {
    this.cacheSelectors(container)
    this.configure()
    this.makeSwiper()
    this.bindUIEvents()
  }

  MobileSlider.prototype.cacheSelectors = function(container) {
    this.cache = {}
    this.cache.$container = $(container)
    this.cache.$mobileSlider = this.cache.$container.find('.js-mobile-slider')
    this.cache.$mobileSwiper = this.cache.$container.find('.js-mobile-swiper')
    this.cache.$anchors = this.cache.$container.find('a')
  }

  MobileSlider.prototype.configure = function() {
    var m = this.cache.$mobileSlider
    this.settings = {
      mediaQueryMediumUp: 'screen and (min-width: 750px)',
      mediaQuerySmall: 'screen and (max-width: 749px)',
      slick: {},
    }
    this.settings.slick.slidesToShow =
      parseInt(m.attr('data-slides-to-show'), 12) || 1
    this.settings.slick.slidesToScroll =
      parseInt(m.attr('data-slides-to-scroll'), 12) || 1
    this.settings.slick.rows = parseInt(m.attr('data-rows'), 12) || 1
    this.settings.slick.dots = !!m.attr('data-dots') || false
    this.settings.slick.arrows = !!m.attr('data-arrows') || false
    this.settings.slick.focusOnSelect =
      !!m.attr('data-focus-on-select') || false
  }

  MobileSlider.prototype.makeSwiper = function() {
    if (this.cache.$mobileSwiper) {
      if (this.swiper && !this.swiper.destroyed) {
        this.swiper.destroy()
      }

      this.swiper = new Swiper(this.cache.$mobileSwiper.selector, {
        init: false,
        slidesPerView: 2,
        slidesPerColumn: 2,
        slidesOffsetAfter: 120,
        spaceBetween: 10,
        freeMode: true,
        slideClass: 'slide',
        wrapperClass: 'mobile-swiper',
        roundLengths: true,
        pagination: {
          el: '.swiper-pagination',
        },
      })
    }
  }

  MobileSlider.prototype.bindUIEvents = function() {
    var self = this
    self.cache.$anchors.on('click', function(e) {
      var $slide = $(this).closest('.slick-slide')
      if ($slide.length && $slide.attr('aria-hidden') === 'true') {
        e.preventDefault()
      }
    })

    // Unslick for medium screens up
    enquire.register(self.settings.mediaQueryMediumUp, {
      match: function() {
        if (self.cache.$mobileSlider.hasClass('slick-initialized')) {
          self.cache.$mobileSlider.slick('unslick')
        }

        if (self.swiper) {
          self.cache.$mobileSwiper.removeClass('swiper-container')
          self.cache.$mobileSwiper
            .find('.mobile-swiper')
            .removeClass('swiper-wrapper')
          self.cache.$mobileSwiper.find('.slide').removeClass('swiper-slide')
          if (self.swiper.initialized) {
            self.makeSwiper()
          }
        }
      },
    })

    // slick on mobile screen
    enquire.register(self.settings.mediaQuerySmall, {
      match: function() {
        if (!self.cache.$mobileSlider.hasClass('slick-initialized')) {
          self.cache.$mobileSlider.slick(self.settings.slick)
        }

        if (self.cache.$mobileSwiper.length) {
          self.cache.$mobileSwiper.addClass('swiper-container')
          self.cache.$mobileSwiper
            .find('.mobile-swiper')
            .addClass('swiper-wrapper')
          self.cache.$mobileSwiper.find('.slide').addClass('swiper-slide')
          if (self.swiper && !self.swiper.initialized) {
            self.swiper.init()
          }
        }
      },
    })
  }

  return MobileSlider
})()

theme.Accordions = (function() {
  function Accordions(container) {
    this.$container = $(container)
    this.$toggle = this.$container.find('.js-accordion-toggle')
    this.bindUIEvents()
  }

  Accordions.prototype.slide = function(el, cb) {
    cb = typeof cb === 'function' ? cb : function() {}
    console.log(el);
    var $this = $(el)
    $('.js-desc-accordion')
      .not($this.next())
      .slideUp(250)
    
    $this.parent().toggleClass('js-accordion-active')
    $('.js-accordion')
      .not($this.parent())
      .removeClass('js-accordion-active')
    $this.next().slideToggle(250, cb)
  }

  Accordions.prototype.bindUIEvents = function() {
    var self = this
    this.$toggle.on('click', function(e) {
      e.preventDefault()
      self.slide(this, function() {
        self.$container.trigger('melanie.slide', this)
      })
    })

    this.$toggle.eq(0).trigger('click')
  }

  return Accordions
})()

/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function() {
  function Drawer(id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openId: 'js-drawer-open-' + id,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position,
    }

    this.nodes = {
      $parent: $('html').add('body'),
      $page: $('#PageContainer'),
      $pageOverlay: $('#PageOverlay'),
    }

    this.config = $.extend(defaults, options)
    this.position = position

    this.$drawer = $('#' + id)

    if (!this.$drawer.length) {
      return false
    }

    this.drawerIsOpen = false
    this.init()
  }

  Drawer.prototype.init = function() {
    if (!this.nodes.$pageOverlay.length) {
      this.nodes.$page.append(
        '<div id="PageOverlay" class="drawer-page-content"></div>'
      )
      this.nodes.$pageOverlay = $('#PageOverlay')
    }

    $(this.config.open).on('click', $.proxy(this.open, this))
    this.$drawer.on('click', this.config.close, $.proxy(this.close, this))
  }

  Drawer.prototype.open = function(evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault()
    } else {
      externalCall = true
    }

    // Without this, the drawer opens, the click event bubbles up to nodes.$page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation()
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget)
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close()
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$drawer.prepareTransition()

    this.nodes.$parent.addClass(
      this.config.openClass +
        ' ' +
        this.config.dirOpenClass +
        ' ' +
        this.config.openId
    )
    this.drawerIsOpen = true

    // Set focus on drawer
    if (!this.config.noA11y) {
      slate.a11y.trapFocus({
        $container: this.$drawer,
        namespace: 'drawer_focus',
      })
    }

    // Run function when draw opens if set
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === 'function'
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen()
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true')
    }

    this.bindEvents()

    return this
  }

  Drawer.prototype.close = function() {
    if (!this.drawerIsOpen) {
      // don't close a closed drawer
      return
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur')

    // Ensure closing transition is applied to moved elements, like the nav
    this.$drawer.prepareTransition()

    this.nodes.$parent.removeClass(
      this.config.dirOpenClass +
        ' ' +
        this.config.openClass +
        ' ' +
        this.config.openId
    )

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'false')
    }

    this.drawerIsOpen = false

    // Remove focus on drawer
    if (!this.config.noA11y) {
      slate.a11y.removeTrapFocus({
        $container: this.$drawer,
        namespace: 'drawer_focus',
      })
    }

    this.unbindEvents()

    // Run function when draw closes if set
    if (
      this.config.onDrawerClose &&
      typeof this.config.onDrawerClose === 'function'
    ) {
      this.config.onDrawerClose()
    }
  }

  Drawer.prototype.bindEvents = function() {
    this.nodes.$parent.on(
      'keyup.drawer',
      $.proxy(function(evt) {
        // close on 'esc' keypress
        if (evt.keyCode === 27) {
          this.close()
          return false
        } else {
          return true
        }
      }, this)
    )

    // Lock scrolling on mobile
    this.nodes.$page.on('touchmove.drawer', function() {
      return false
    })

    this.nodes.$pageOverlay.on(
      'click.drawer',
      $.proxy(function() {
        this.close()
        return false
      }, this)
    )
  }

  Drawer.prototype.unbindEvents = function() {
    this.nodes.$page.off('.drawer')
    this.nodes.$parent.off('.drawer')
  }

  return Drawer
})()

/* ================ MODULES ================ */
window.theme = window.theme || {}

theme.Header = (function() {
  var timeout
  var initialDelay = 200
  var closeDelay = 150
  var changeDelay = 100

  var selectors = {
    body: 'body',
    navigation: '#AccessibleNav',
    siteNavHasDropdown: '.site-nav--has-dropdown',
    siteNavChildLinks: '.site-nav__child-link',
    siteNavActiveDropdown: '.site-nav--active-dropdown',
    siteNavLinkMain: '.site-nav__link--main',
    siteNavChildLink: '.site-nav__link--last',
    headerContainer: '#header-container',
    catNav: '#cat-nav',
  }

  var config = {
    activeClass: 'site-nav--active-dropdown',
    childLinkClass: 'site-nav__child-link',
  }

  var cache = {}

  function init() {
    cacheSelectors()

    cache.$catNav.on('click.siteNav', function(e) {
      e.stopPropagation()
    })

    $(selectors.siteNavChildLink).on('mouseleave', function() {
      setTimeout(function() {
        if (
          $(document.activeElement).hasClass(config.childLinkClass) ||
          !cache.$activeDropdown.length
        ) {
          return
        }

        hideDropdown(cache.$activeDropdown)
      })
    })

    cache.$parents.on('mouseenter touchstart', function(e) {
      clearTimeout(timeout)
      var $el = $(this)

      if (!$el.hasClass(config.activeClass)) {
        e.preventDefault()
      }

      var timeDelay = cache.$activeDropdown.length ? changeDelay : initialDelay

      timeout = setTimeout(showDropdown.bind(null, $el), timeDelay)
    })

    cache.$parents.on('mouseleave', function() {
      clearTimeout(timeout)
      timeout = setTimeout(function() {
        hideDropdown(cache.$activeDropdown)
      }, closeDelay)
    })

    cache.$catNav.on('mouseenter touchstart', function(e) {
      clearTimeout(timeout)
      showDropdown(cache.$activeDropdown)
    })

    cache.$catNav.on('mouseleave', function() {
      clearTimeout(timeout)
      timeout = setTimeout(function() {
        hideDropdown(cache.$activeDropdown)
      }, closeDelay)
    })

    cache.$siteNavDropdown.on('mouseenter touchstart', function(e) {
      e.stopImmediatePropagation()
    })
  }

  function cacheSelectors() {
    cache = {
      $nav: $(selectors.navigation),
      $topLevel: $(selectors.siteNavLinkMain),
      $parents: $(selectors.navigation).find(selectors.siteNavHasDropdown),
      $subMenuLinks: $(selectors.siteNavChildLinks),
      $activeDropdown: $(selectors.siteNavActiveDropdown),
      $siteNavDropdown: $(selectors.siteNavDropdown),
      $headerContainer: $(selectors.headerContainer),
      $catNav: $(selectors.catNav),
    }
  }

  function showDropdown($el) {
    $el.addClass(config.activeClass)

    // close open dropdowns
    if (cache.$activeDropdown.length) {
      hideDropdown(cache.$activeDropdown)
    }

    cache.$activeDropdown = $el

    // set expanded on open dropdown
    $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'true')

    var $link = $el.find(selectors.siteNavLinkMain)
    var $cat = cache.$catNav.find('#' + $link.attr('aria-controls'))

    if ($cat.length) {
      cache.$catNav.attr('aria-expanded', 'true')
      cache.$catNav.show()
      $cat.show()
    }

    setTimeout(function() {
      $(window).on('keyup.siteNav', function(evt) {
        if (evt.keyCode === 27) {
          hideDropdown($el)
        }
      })

      $(selectors.body).on('click.siteNav', function() {
        hideDropdown($el)
      })
    }, 250)
  }

  function hideDropdown($el) {
    // remove aria on open dropdown
    $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'false')
    $el.removeClass(config.activeClass)
    cache.$headerContainer.removeClass(config.activeClass)

    var $link = $el.find(selectors.siteNavLinkMain)
    var $cat = cache.$catNav.find('#' + $link.attr('aria-controls'))

    if ($cat.length) {
      cache.$catNav.attr('aria-expanded', 'false')
      cache.$catNav.hide()
      $cat.hide()
    }

    // reset active dropdown
    cache.$activeDropdown = $(selectors.siteNavActiveDropdown)

    $(selectors.body).off('click.siteNav')
    $(window).off('keyup.siteNav')
  }

  function unload() {
    $(window).off('.siteNav')
    cache.$parents.off('.siteNav')
    cache.$subMenuLinks.off('.siteNav')
    cache.$topLevel.off('.siteNav')
    $(selectors.siteNavChildLink).off('.siteNav')
    $(selectors.body).off('.siteNav')
  }

  return {
    init: init,
    unload: unload,
  }
})()

window.theme = window.theme || {}

theme.MobileNav = (function() {
  function init() {
    theme.MobileDrawer = new theme.Drawers('nav-drawer', 'left', {})

    $('.js-toggle-submenu').on('click', function(e) {
      var $this = $(this)
      $this.next().slideToggle('fast')
      $this.find('.mm__icon').toggleClass('is-active')
    })
  }
  return {
    init: init,
  }
})(jQuery)

theme.AjaxCart = (function() {
  var cache = {}

  function cacheSelectors() {
    cache.$body = $(document.body)
    cache.$quickAdd = $('.js-quick-add')
    cache.$cartCount = $('.js-cart-count')
    cache.$cartCountWrapper = $('.js-cart-count-wrapper')
    cache.$document = $(document)
  }

  // From Timber's AJAX Cart
  function validateQty(qty) {
    return parseFloat(qty) === parseInt(qty) && !isNaN(qty) ? qty : 1
  }

  function handleInputQtyChange() {
    var qty = validateQty(
      parseInt(
        $(this)
          .val()
          .replace(/\D/g, '')
      )
    )
    var line = $(this).data('line')
    if (line) {
      CartJS.updateItem(line, qty)
    }
  }

  function handleRequestComplete(e, cart) {
    theme.CartDrawer.open()
    var method = cart.item_count ? 'removeClass' : 'addClass'
    cache.$cartCountWrapper[method]('hide')
    cache.$cartCount.html(cart.item_count)
  }

  function handleQuickAdd(e) {
    e.preventDefault()
    var id = Number($(this).data('id'))
    if (id) {
      CartJS.addItem(id)
    }
  }

  function bindUIEvents() {
    cache.$document.on('cart.requestComplete', handleRequestComplete)
    cache.$body.on('change', '.js-qty-input', handleInputQtyChange)
    cache.$quickAdd.on('click', handleQuickAdd)
  }

  function run() {
    cacheSelectors()
    CartJS.init(theme.cart, {
      moneyFormat: theme.moneyFormat,
      moneyWithCurrencyFormat: theme.moneyWithCurrencyFormat,
      formatMoney: theme.Currency.formatMoney,
      requestBodyClass: 'cart-is-requesting',
      getSizedImageUrl: theme.Images.getSizedImageUrl,
    })

    theme.CartDrawer = new theme.Drawers('shopify-section-ajax-cart', 'right', {
      onDrawerOpen: function() {
        $(document.body).trigger('cart.open')
      },
      onDrawerClose: function() {
        $(document.body).trigger('cart.close')
      },
    })

    $('.js-open-cart-drawer').on(
      'click',
      theme.CartDrawer.open.bind(theme.CartDrawer)
    )

    bindUIEvents()
  }

  function init() {
    if ($('#shopify-section-ajax-cart').length) {
      run()
    }
  }

  return {
    init: init,
  }
})(jQuery)

window.theme = window.theme || {}

theme.Search = (function() {
  var selectors = {
    search: '.search',
    searchSubmit: '.search__submit',
    searchInput: '.search__input',

    siteHeader: '.site-header',
    siteHeaderSearchToggle: '.site-header__search-toggle',
    siteHeaderSearch: '.site-header__search',

    searchDrawer: '.search-bar',
    searchDrawerInput: '.search-bar__input',

    searchHeader: '.search-header',
    searchHeaderInput: '.search-header__input',
    searchHeaderSubmit: '.search-header__submit',

    mobileNavWrapper: '.mobile-nav-wrapper',
  }

  var classes = {
    focus: 'search--focus',
    mobileNavIsOpen: 'js-menu--is-open',
  }

  function init() {
    if (!$(selectors.siteHeader).length) {
      return
    }

    initDrawer()
    searchSubmit()

    $(selectors.searchHeaderInput)
      .add(selectors.searchHeaderSubmit)
      .on('focus blur', function() {
        $(selectors.searchHeader).toggleClass(classes.focus)
      })

    $(selectors.siteHeaderSearchToggle).on('click', function() {
      var searchHeight = $(selectors.siteHeader).outerHeight()
      var searchOffset = $(selectors.siteHeader).offset().top - searchHeight

      $(selectors.searchDrawer).css({
        height: searchHeight + 'px',
        top: searchOffset + 'px',
      })
    })
  }

  function initDrawer() {
    // Add required classes to HTML
    $('.js-drawer-open-top')
      .attr('aria-controls', 'SearchDrawer')
      .attr('aria-expanded', 'false')
      .attr('aria-haspopup', 'dialog')

    theme.SearchDrawer = new theme.Drawers('SearchDrawer', 'top', {
      onDrawerOpen: searchDrawerFocus,
      onDrawerClose: searchDrawerFocusClose,
    })
  }

  function searchDrawerFocus() {
    searchFocus($(selectors.searchDrawerInput))

    if ($(selectors.mobileNavWrapper).hasClass(classes.mobileNavIsOpen)) {
      theme.MobileNav.closeMobileNav()
    }
  }

  function searchFocus($el) {
    $el.focus()
    // set selection range hack for iOS
    $el[0].setSelectionRange(0, $el[0].value.length)
  }

  function searchDrawerFocusClose() {
    $(selectors.siteHeaderSearchToggle).focus()
  }

  function searchSubmit() {
    $(selectors.searchSubmit).on('click', function(evt) {
      var $el = $(evt.target)
      var $input = $el.parents(selectors.search).find(selectors.searchInput)
      if ($input.val().length === 0) {
        evt.preventDefault()
        searchFocus($input)
      }
    })
  }

  return {
    init: init,
  }
})()
;(function() {
  var selectors = {
    backButton: '.return-link',
  }

  var $backButton = $(selectors.backButton)

  if (!document.referrer || !$backButton.length || !window.history.length) {
    return
  }

  $backButton.one('click', function(evt) {
    evt.preventDefault()

    var referrerDomain = urlDomain(document.referrer)
    var shopDomain = urlDomain(window.location.href)

    if (shopDomain === referrerDomain) {
      history.back()
    }

    return false
  })

  function urlDomain(url) {
    var anchor = document.createElement('a')
    anchor.ref = url

    return anchor.hostname
  }
})()

theme.Slideshow = (function() {
  this.$slideshow = null
  var classes = {
    wrapper: 'slideshow-wrapper',
    slideshow: 'slideshow',
    currentSlide: 'slick-current',
    video: 'slideshow__video',
    videoBackground: 'slideshow__video--background',
    closeVideoBtn: 'slideshow__video-control--close',
    pauseButton: 'slideshow__pause',
    isPaused: 'is-paused',
  }

  function slideshow(el) {
    this.$slideshow = $(el)
    this.$wrapper = this.$slideshow.closest('.' + classes.wrapper)
    this.$pause = this.$wrapper.find('.' + classes.pauseButton)

    this.settings = {
      accessibility: true,
      arrows: false,
      dots: true,
      // fade: true,
      draggable: true,
      touchThreshold: 20,
      // fade: false,
      autoplay: this.$slideshow.data('autoplay'),
      autoplaySpeed: this.$slideshow.data('speed'),
    }

    this.$slideshow.on('beforeChange', beforeChange.bind(this))
    this.$slideshow.on('init', slideshowA11y.bind(this))
    this.$slideshow.slick(this.settings)

    this.$pause.on('click', this.togglePause.bind(this))
  }

  function slideshowA11y(event, obj) {
    var $slider = obj.$slider
    var $list = obj.$list
    var $wrapper = this.$wrapper
    var autoplay = this.settings.autoplay

    // Remove default Slick aria-live attr until slider is focused
    $list.removeAttr('aria-live')

    // When an element in the slider is focused
    // pause slideshow and set aria-live.
    $wrapper.on('focusin', function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return
      }

      $list.attr('aria-live', 'polite')

      if (autoplay) {
        $slider.slick('slickPause')
      }
    })

    // Resume autoplay
    $wrapper.on('focusout', function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return
      }

      $list.removeAttr('aria-live')

      if (autoplay) {
        // Manual check if the focused element was the video close button
        // to ensure autoplay does not resume when focus goes inside YouTube iframe
        if ($(evt.target).hasClass(classes.closeVideoBtn)) {
          return
        }

        $slider.slick('slickPlay')
      }
    })

    // Add arrow key support when focused
    if (obj.$dots) {
      obj.$dots.on('keydown', function(evt) {
        if (evt.which === 37) {
          $slider.slick('slickPrev')
        }

        if (evt.which === 39) {
          $slider.slick('slickNext')
        }

        // Update focus on newly selected tab
        if (evt.which === 37 || evt.which === 39) {
          obj.$dots.find('.slick-active button').focus()
        }
      })
    }
  }

  function beforeChange(event, slick, currentSlide, nextSlide) {
    var $slider = slick.$slider
    var $currentSlide = $slider.find('.' + classes.currentSlide)
    var $nextSlide = $slider.find(
      '.slideshow__slide[data-slick-index="' + nextSlide + '"]'
    )

    if (isVideoInSlide($currentSlide)) {
      var $currentVideo = $currentSlide.find('.' + classes.video)
      var currentVideoId = $currentVideo.attr('id')
      theme.SlideshowVideo.pauseVideo(currentVideoId)
      $currentVideo.attr('tabindex', '-1')
    }

    if (isVideoInSlide($nextSlide)) {
      var $video = $nextSlide.find('.' + classes.video)
      var videoId = $video.attr('id')
      var isBackground = $video.hasClass(classes.videoBackground)
      if (isBackground) {
        theme.SlideshowVideo.playVideo(videoId)
      } else {
        $video.attr('tabindex', '0')
      }
    }
  }

  function isVideoInSlide($slide) {
    return $slide.find('.' + classes.video).length
  }

  slideshow.prototype.togglePause = function() {
    var slideshowSelector = getSlideshowId(this.$pause)
    if (this.$pause.hasClass(classes.isPaused)) {
      this.$pause.removeClass(classes.isPaused)
      $(slideshowSelector).slick('slickPlay')
    } else {
      this.$pause.addClass(classes.isPaused)
      $(slideshowSelector).slick('slickPause')
    }
  }

  function getSlideshowId($el) {
    return '#Slideshow-' + $el.data('id')
  }

  return slideshow
})()

// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady() {
  theme.SlideshowVideo.loadVideos()
}

theme.SlideshowVideo = (function() {
  var autoplayCheckComplete = false
  var autoplayAvailable = false
  var playOnClickChecked = false
  var playOnClick = false
  var youtubeLoaded = false
  var videos = {}
  var videoPlayers = []
  var videoOptions = {
    ratio: 16 / 9,
    playerVars: {
      // eslint-disable-next-line camelcase
      iv_load_policy: 3,
      modestbranding: 1,
      autoplay: 0,
      controls: 0,
      showinfo: 0,
      wmode: 'opaque',
      branding: 0,
      autohide: 0,
      rel: 0,
    },
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerChange,
    },
  }
  var classes = {
    playing: 'video-is-playing',
    paused: 'video-is-paused',
    loading: 'video-is-loading',
    loaded: 'video-is-loaded',
    slideshowWrapper: 'slideshow-wrapper',
    slide: 'slideshow__slide',
    slideBackgroundVideo: 'slideshow__slide--background-video',
    slideDots: 'slick-dots',
    videoChrome: 'slideshow__video--chrome',
    videoBackground: 'slideshow__video--background',
    playVideoBtn: 'slideshow__video-control--play',
    closeVideoBtn: 'slideshow__video-control--close',
    currentSlide: 'slick-current',
    slickClone: 'slick-cloned',
    supportsAutoplay: 'autoplay',
    supportsNoAutoplay: 'no-autoplay',
  }

  /**
   * Public functions
   */
  function init($video) {
    if (!$video.length) {
      return
    }

    videos[$video.attr('id')] = {
      id: $video.attr('id'),
      videoId: $video.data('id'),
      type: $video.data('type'),
      status: $video.data('type') === 'chrome' ? 'closed' : 'background', // closed, open, background
      videoSelector: $video.attr('id'),
      $parentSlide: $video.closest('.' + classes.slide),
      $parentSlideshowWrapper: $video.closest('.' + classes.slideshowWrapper),
      controls: $video.data('type') === 'background' ? 0 : 1,
      slideshow: $video.data('slideshow'),
    }

    if (!youtubeLoaded) {
      // This code loads the IFrame Player API code asynchronously.
      var tag = document.createElement('script')
      tag.src = 'https://www.youtube.com/iframe_api'
      var firstScriptTag = document.getElementsByTagName('script')[0]
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
    }
  }

  function customPlayVideo(playerId) {
    // Do not autoplay just because the slideshow asked you to.
    // If the slideshow asks to play a video, make sure
    // we have done the playOnClick check first
    if (!playOnClickChecked && !playOnClick) {
      return
    }

    if (playerId && typeof videoPlayers[playerId].playVideo === 'function') {
      privatePlayVideo(playerId)
    }
  }

  function pauseVideo(playerId) {
    if (
      videoPlayers[playerId] &&
      typeof videoPlayers[playerId].pauseVideo === 'function'
    ) {
      videoPlayers[playerId].pauseVideo()
    }
  }

  function loadVideos() {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var args = $.extend({}, videoOptions, videos[key])
        args.playerVars.controls = args.controls
        videoPlayers[key] = new YT.Player(key, args)
      }
    }

    initEvents()
    youtubeLoaded = true
  }

  function loadVideo(key) {
    if (!youtubeLoaded) {
      return
    }
    var args = $.extend({}, videoOptions, videos[key])
    args.playerVars.controls = args.controls
    videoPlayers[key] = new YT.Player(key, args)

    initEvents()
  }

  /**
   * Private functions
   */

  function privatePlayVideo(id, clicked) {
    var videoData = videos[id]
    var player = videoPlayers[id]
    var $slide = videos[id].$parentSlide

    if (playOnClick) {
      // playOnClick means we are probably on mobile (no autoplay).
      // setAsPlaying will show the iframe, requiring another click
      // to play the video.
      setAsPlaying(videoData)
    } else if (clicked || (autoplayCheckComplete && autoplayAvailable)) {
      // Play if autoplay is available or clicked to play
      $slide.removeClass(classes.loading)
      setAsPlaying(videoData)
      player.playVideo()
      return
    }

    // Check for autoplay if not already done
    if (!autoplayCheckComplete) {
      autoplayCheckFunction(player, $slide)
    }
  }

  function setAutoplaySupport(supported) {
    var supportClass = supported
      ? classes.supportsAutoplay
      : classes.supportsNoAutoplay
    $(document.documentElement).addClass(supportClass)

    if (!supported) {
      playOnClick = true
    }

    autoplayCheckComplete = true
  }

  function autoplayCheckFunction(player, $slide) {
    // attempt to play video
    player.playVideo()

    autoplayTest(player)
      .then(function() {
        setAutoplaySupport(true)
      })
      .fail(function() {
        // No autoplay available (or took too long to start playing).
        // Show fallback image. Stop video for safety.
        setAutoplaySupport(false)
        player.stopVideo()
      })
      .always(function() {
        autoplayCheckComplete = true
        $slide.removeClass(classes.loading)
      })
  }

  function autoplayTest(player) {
    var deferred = $.Deferred()
    var wait
    var timeout

    wait = setInterval(function() {
      if (player.getCurrentTime() <= 0) {
        return
      }

      autoplayAvailable = true
      clearInterval(wait)
      clearTimeout(timeout)
      deferred.resolve()
    }, 500)

    timeout = setTimeout(function() {
      clearInterval(wait)
      deferred.reject()
    }, 4000) // subjective. test up to 8 times over 4 seconds

    return deferred
  }

  function playOnClickCheck() {
    // Bail early for a few instances:
    // - small screen
    // - device sniff mobile browser

    if (playOnClickChecked) {
      return
    }

    if ($(window).width() < 750) {
      playOnClick = true
    } else if (window.mobileCheck()) {
      playOnClick = true
    }

    if (playOnClick) {
      // No need to also do the autoplay check
      setAutoplaySupport(false)
    }

    playOnClickChecked = true
  }

  // The API will call this function when each video player is ready
  function onPlayerReady(evt) {
    evt.target.setPlaybackQuality('hd1080')
    var videoData = getVideoOptions(evt)

    playOnClickCheck()

    // Prevent tabbing through YouTube player controls until visible
   // $('#' + videoData.id).attr('tabindex', '-1')

    sizeBackgroundVideos()

    // Customize based on options from the video ID
    switch (videoData.type) {
      case 'background-chrome':
      case 'background':
        evt.target.mute()
        // Only play the video if it is in the active slide
        if (videoData.$parentSlide.hasClass(classes.currentSlide)) {
          privatePlayVideo(videoData.id)
        }
        break
    }

    videoData.$parentSlide.addClass(classes.loaded)
  }

  function onPlayerChange(evt) {
    var videoData = getVideoOptions(evt)

    switch (evt.data) {
      case 0: // ended
        setAsFinished(videoData)
        break
      case 1: // playing
        setAsPlaying(videoData)
        break
      case 2: // paused
        setAsPaused(videoData)
        break
    }
  }

  function setAsFinished(videoData) {
    switch (videoData.type) {
      case 'background':
        videoPlayers[videoData.id].seekTo(0)
        break
      case 'background-chrome':
        videoPlayers[videoData.id].seekTo(0)
        closeVideo(videoData.id)
        break
      case 'chrome':
        closeVideo(videoData.id)
        break
    }
  }

  function setAsPlaying(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper
    var $slide = videoData.$parentSlide

    $slide.removeClass(classes.loading)

    // Do not change element visibility if it is a background video
    if (videoData.status === 'background') {
      return
    }

    $('#' + videoData.id).attr('tabindex', '0')

    switch (videoData.type) {
      case 'chrome':
      case 'background-chrome':
        $slideshow.removeClass(classes.paused).addClass(classes.playing)
        $slide.removeClass(classes.paused).addClass(classes.playing)
        break
    }

    // Update focus to the close button so we stay within the slide
    $slide.find('.' + classes.closeVideoBtn).focus()
  }

  function setAsPaused(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper
    var $slide = videoData.$parentSlide

    if (videoData.type === 'background-chrome') {
      closeVideo(videoData.id)
      return
    }

    // YT's events fire after our click event. This status flag ensures
    // we don't interact with a closed or background video.
    if (videoData.status !== 'closed' && videoData.type !== 'background') {
      $slideshow.addClass(classes.paused)
      $slide.addClass(classes.paused)
    }

    if (videoData.type === 'chrome' && videoData.status === 'closed') {
      $slideshow.removeClass(classes.paused)
      $slide.removeClass(classes.paused)
    }

    $slideshow.removeClass(classes.playing)
    $slide.removeClass(classes.playing)
  }

  function closeVideo(playerId) {
    var videoData = videos[playerId]
    var $slideshow = videoData.$parentSlideshowWrapper
    var $slide = videoData.$parentSlide
    var classesToRemove = [classes.pause, classes.playing].join(' ')

    $('#' + videoData.id).attr('tabindex', '-1')

    videoData.status = 'closed'

    switch (videoData.type) {
      case 'background-chrome':
        videoPlayers[playerId].mute()
        setBackgroundVideo(playerId)
        break
      case 'chrome':
        videoPlayers[playerId].stopVideo()
        setAsPaused(videoData) // in case the video is already paused
        break
    }

    $slideshow.removeClass(classesToRemove)
    $slide.removeClass(classesToRemove)
  }

  function getVideoOptions(evt) {
    return videos[evt.target.h.id]
  }

  function startVideoOnClick(playerId) {
    var videoData = videos[playerId]
    // add loading class to slide
    videoData.$parentSlide.addClass(classes.loading)

    videoData.status = 'open'

    switch (videoData.type) {
      case 'background-chrome':
        unsetBackgroundVideo(playerId, videoData)
        videoPlayers[playerId].unMute()
        privatePlayVideo(playerId, true)
        break
      case 'chrome':
        privatePlayVideo(playerId, true)
        break
    }

    // esc to close video player
    $(document).on('keydown.videoPlayer', function(evt) {
      if (evt.keyCode === 27) {
        closeVideo(playerId)
      }
    })
  }

  function sizeBackgroundVideos() {
    $('.' + classes.videoBackground).each(function(index, el) {
      sizeBackgroundVideo($(el))
    })
  }

  function sizeBackgroundVideo($player) {
    var $slide = $player.closest('.' + classes.slide)
    // Ignore cloned slides
    if ($slide.hasClass(classes.slickClone)) {
      return
    }
    var slideWidth = $slide.width()
    var playerWidth = $player.width()
    var playerHeight = $player.height()

    // when screen aspect ratio differs from video, video must center and underlay one dimension
    if (slideWidth / videoOptions.ratio < playerHeight) {
      playerWidth = Math.ceil(playerHeight * videoOptions.ratio) // get new player width
      $player
        .width(playerWidth)
        .height(playerHeight)
        .css({
          left: (slideWidth - playerWidth) / 2,
          top: 0,
        }) // player width is greater, offset left; reset top
    } else {
      // new video width < window width (gap to right)
      playerHeight = Math.ceil(slideWidth / videoOptions.ratio) // get new player height
      $player
        .width(slideWidth)
        .height(playerHeight)
        .css({
          left: 0,
          top: (playerHeight - playerHeight) / 2,
        }) // player height is greater, offset top; reset left
    }

    $player.prepareTransition().addClass(classes.loaded)
  }

  function unsetBackgroundVideo(playerId) {
    // Switch the background-chrome to a chrome-only player once played
    $('#' + playerId)
      .removeAttr('style')
      .removeClass(classes.videoBackground)
      .addClass(classes.videoChrome)

    videos[playerId].$parentSlideshowWrapper
      .removeClass(classes.slideBackgroundVideo)
      .addClass(classes.playing)

    videos[playerId].$parentSlide
      .removeClass(classes.slideBackgroundVideo)
      .addClass(classes.playing)

    videos[playerId].status = 'open'
  }

  function setBackgroundVideo(playerId) {
    // Switch back to background-chrome when closed
    var $player = $('#' + playerId)
      .addClass(classes.videoBackground)
      .removeClass(classes.videoChrome)

    videos[playerId].$parentSlide.addClass(classes.slideBackgroundVideo)

    videos[playerId].status = 'background'
    sizeBackgroundVideo($player)
  }

  function initEvents() {
    $(document).on('click.videoPlayer', '.' + classes.playVideoBtn, function(
      evt
    ) {
      var playerId = $(evt.currentTarget).data('controls')
      startVideoOnClick(playerId)
    })

    $(document).on('click.videoPlayer', '.' + classes.closeVideoBtn, function(
      evt
    ) {
      var playerId = $(evt.currentTarget).data('controls')
      closeVideo(playerId)
    })

    // Listen to resize to keep a background-size:cover-like layout
    $(window).on(
      'resize.videoPlayer',
      $.debounce(250, function() {
        if (youtubeLoaded) {
          sizeBackgroundVideos()
        }
      })
    )
  }

  function removeEvents() {
    $(document).off('.videoPlayer')
    $(window).off('.videoPlayer')
  }

  return {
    init: init,
    loadVideos: loadVideos,
    loadVideo: loadVideo,
    playVideo: customPlayVideo,
    pauseVideo: pauseVideo,
    removeEvents: removeEvents,
  }
})()

/* ================ TEMPLATES ================ */
;(function() {
  var $filterBy = $('#BlogTagFilter')

  if (!$filterBy.length) {
    return
  }

  $filterBy.on('change', function() {
    location.href = $(this).val()
  })
})()

window.theme = theme || {}

theme.customerTemplates = (function() {
  function initEventListeners() {
    // Show reset password form
    $('#RecoverPassword').on('click', function(evt) {
      evt.preventDefault()
      toggleRecoverPasswordForm()
    })

    // Hide reset password form
    $('#HideRecoverPasswordLink').on('click', function(evt) {
      evt.preventDefault()
      toggleRecoverPasswordForm()
    })
  }

  /**
   *
   *  Show/Hide recover password form
   *
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide')
    $('#CustomerLoginForm').toggleClass('hide')
  }

  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success')

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return
    }

    // show success message
    $('#ResetSuccess').removeClass('hide')
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    var $newAddressForm = $('#AddressNewForm')

    if (!$newAddressForm.length) {
      return
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(
        'AddressCountryNew',
        'AddressProvinceNew',
        {
          hideElement: 'AddressProvinceContainerNew',
        }
      )
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function() {
      var formId = $(this).data('form-id')
      var countrySelector = 'AddressCountry_' + formId
      var provinceSelector = 'AddressProvince_' + formId
      var containerSelector = 'AddressProvinceContainer_' + formId

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector,
      })
    })

    // Toggle new/edit address forms
    $('.address-new-toggle').on('click', function() {
      $newAddressForm.toggleClass('hide')
    })

    $('.address-edit-toggle').on('click', function() {
      var formId = $(this).data('form-id')
      $('#EditAddress_' + formId).toggleClass('hide')
    })

    $('.address-delete').on('click', function() {
      var $el = $(this)
      var formId = $el.data('form-id')
      var confirmMessage = $el.data('confirm-message')

      // eslint-disable-next-line no-alert
      if (
        confirm(
          confirmMessage || 'Are you sure you wish to delete this address?'
        )
      ) {
        Shopify.postLink('/account/addresses/' + formId, {
          parameters: { _method: 'delete' },
        })
      }
    })
  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    var hash = window.location.hash

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm()
    }
  }

  return {
    init: function() {
      checkUrlHash()
      initEventListeners()
      resetPasswordSuccess()
      customerAddressForm()
    },
  }
})()

/*================ SECTIONS ================*/
window.theme = window.theme || {}

theme.Cart = (function() {
  var selectors = {
    edit: '.js-edit-toggle',
  }
  var config = {
    showClass: 'cart__update--show',
    showEditClass: 'cart__edit--active',
    cartNoCookies: 'cart--no-cookies',
  }

  function Cart(container) {
    this.$container = $(container)
    this.$edit = $(selectors.edit, this.$container)

    if (!this.cookiesEnabled()) {
      this.$container.addClass(config.cartNoCookies)
    }

    this.$edit.on('click', this._onEditClick.bind(this))
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {
    onUnload: function() {
      this.$edit.off('click', this._onEditClick)
    },

    _onEditClick: function(evt) {
      var $evtTarget = $(evt.target)
      var $updateLine = $('.' + $evtTarget.data('target'))

      $evtTarget.toggleClass(config.showEditClass)
      $updateLine.toggleClass(config.showClass)
    },

    cookiesEnabled: function() {
      var cookieEnabled = navigator.cookieEnabled

      if (!cookieEnabled) {
        document.cookie = 'testcookie'
        cookieEnabled = document.cookie.indexOf('testcookie') !== -1
      }
      return cookieEnabled
    },
  })

  return Cart
})()

window.theme = window.theme || {}

theme.Filters = (function() {
  var constants = {
    SORT_BY: 'sort_by',
  }
  var selectors = {
    filterSelection: '#SortTags',
    sortSelection: '#SortBy',
    defaultSort: '#DefaultSortBy',
    toggle: '#PleaseClickHereToToggleTheCollectionFilterSidebarMenu',
    sidebarGrid: '#collection-sidebar-grid',
    bodyGrid: '#collection-body-grid',
    searchInput: '#filter-search',
    searchList: '#filter-search-list',
  }

  function Filters(container) {
    var $container = (this.$container = $(container))

    this.$filterSelect = $(selectors.filterSelection, $container)
    this.$sortSelect = $(selectors.sortSelection, $container)
    this.$selects = $(selectors.filterSelection, $container).add(
      $(selectors.sortSelection, $container)
    )
    this.$toggle = $(selectors.toggle)
    this.$sidebar = $(selectors.sidebarGrid)
    this.$body = $(selectors.bodyGrid)
    this.$searchInput = $(selectors.searchInput)

    this.defaultSort = this._getDefaultSortValue()
    this._resizeSelect(this.$selects)
    this.$selects.removeClass('hidden')

    this.$filterSelect.on('change', this._onFilterChange.bind(this))
    this.$sortSelect.on('change', this._onSortChange.bind(this))
    this.$toggle.on('click', this._onClickToggle.bind(this))
    this.$searchInput.on('input', this._onChangeSearchInput.bind(this))
    this.$searchList = $(selectors.searchList)
    this.state = {
      isFilterVisible: false,
    }

    theme.FilterDrawer = new theme.Drawers('FilterDrawer', 'right', {
      noA11y: true,
    })
  }

  Filters.prototype = _.assignIn({}, Filters.prototype, {
    _onClickToggle: function(e) {
      theme.FilterDrawer.open(e)
    },

    _onChangeSearchInput: function(e) {
      var value = e.target.value.toUpperCase()

      this.$searchList.find('li').each(function() {
        var text = $(this)
          .text()
          .toUpperCase()
        if (text.indexOf(value) !== -1 || !value) {
          $(this).show()
        } else {
          $(this).hide()
        }
      })
    },

    _onSortChange: function(evt) {
      var sort = this._sortValue()
      if (sort.length) {
        window.location.search = sort
      } else {
        // clean up our url if the sort value is blank for default
        window.location.href = window.location.href.replace(
          window.location.search,
          ''
        )
      }
      this._resizeSelect($(evt.target))
    },

    _onFilterChange: function(evt) {
      var filter = this._getFilterValue()

      // remove the 'page' parameter to go to the first page of results
      var search = document.location.search.replace(/\?(page=\w+)?&?/, '')

      // only add the search parameters to the url if they exist
      search = search !== '' ? '?' + search : ''

      document.location.href = filter + search
      this._resizeSelect($(evt.target))
    },

    _getFilterValue: function() {
      return this.$filterSelect.val()
    },

    _getSortValue: function() {
      return this.$sortSelect.val() || this.defaultSort
    },

    _getDefaultSortValue: function() {
      return $(selectors.defaultSort, this.$container).val()
    },

    _sortValue: function() {
      var sort = this._getSortValue()
      var query = ''

      if (sort !== this.defaultSort) {
        query = constants.SORT_BY + '=' + sort
      }

      return query
    },

    _resizeSelect: function($selection) {
      $selection.each(function() {
        var $this = $(this)
        var arrowWidth = 10
        // create test element
        var text = $this.find('option:selected').text()
        var $test = $('<span>').html(text)

        // add to body, get width, and get out
        $test.appendTo('body')
        var width = $test.width()
        $test.remove()

        // set select width
        $this.width(width + arrowWidth)
      })
    },

    onUnload: function() {
      this.$filterSelect.off('change', this._onFilterChange)
      this.$sortSelect.off('change', this._onSortChange)
    },
  })

  return Filters
})()

window.theme = window.theme || {}

theme.HeaderSection = (function() {
  function Header() {
    theme.Header.init()
    theme.MobileNav.init()
    theme.AjaxCart.init()
    theme.Search.init()
  }

  Header.prototype = _.assignIn({}, Header.prototype, {
    onUnload: function() {
      theme.Header.unload()
    },
  })

  return Header
})()

theme.Maps = (function() {
  var config = {
    zoom: 14,
  }
  var apiStatus = null
  var mapsToLoad = []

  var errors = {
    addressNoResults: theme.strings.addressNoResults,
    addressQueryLimit: theme.strings.addressQueryLimit,
    addressError: theme.strings.addressError,
    authError: theme.strings.authError,
  }

  var selectors = {
    section: '[data-section-type="map"]',
    map: '[data-map]',
    mapOverlay: '[data-map-overlay]',
  }

  var classes = {
    mapError: 'map-section--load-error',
    errorMsg: 'map-section__error errors text-center',
  }

  // Global function called by Google on auth errors.
  // Show an auto error message on all map instances.
  // eslint-disable-next-line camelcase, no-unused-vars
  window.gm_authFailure = function() {
    if (!Shopify.designMode) {
      return
    }

    $(selectors.section).addClass(classes.mapError)
    $(selectors.map).remove()
    $(selectors.mapOverlay).after(
      '<div class="' +
        classes.errorMsg +
        '">' +
        theme.strings.authError +
        '</div>'
    )
  }

  function Map(container) {
    this.$container = $(container)
    this.$map = this.$container.find(selectors.map)
    this.key = this.$map.data('api-key')

    if (typeof this.key === 'undefined') {
      return
    }

    if (apiStatus === 'loaded') {
      this.createMap()
    } else {
      mapsToLoad.push(this)

      if (apiStatus !== 'loading') {
        apiStatus = 'loading'
        if (typeof window.google === 'undefined') {
          $.getScript(
            'https://maps.googleapis.com/maps/api/js?key=' + this.key
          ).then(function() {
            apiStatus = 'loaded'
            initAllMaps()
          })
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function(index, instance) {
      instance.createMap()
    })
  }

  function geolocate($map) {
    var deferred = $.Deferred()
    var geocoder = new google.maps.Geocoder()
    var address = $map.data('address-setting')

    geocoder.geocode({ address: address }, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status)
      }

      deferred.resolve(results)
    })

    return deferred
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function() {
      var $map = this.$map

      return geolocate($map)
        .then(
          function(results) {
            var mapOptions = {
              zoom: config.zoom,
              center: results[0].geometry.location,
              draggable: false,
              clickableIcons: false,
              scrollwheel: false,
              disableDoubleClickZoom: true,
              disableDefaultUI: true,
            }

            var map = (this.map = new google.maps.Map($map[0], mapOptions))
            var center = (this.center = map.getCenter())

            //eslint-disable-next-line no-unused-vars
            var marker = new google.maps.Marker({
              map: map,
              position: map.getCenter(),
            })

            google.maps.event.addDomListener(
              window,
              'resize',
              $.debounce(250, function() {
                google.maps.event.trigger(map, 'resize')
                map.setCenter(center)
                $map.removeAttr('style')
              })
            )
          }.bind(this)
        )
        .fail(function() {
          var errorMessage

          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = errors.addressNoResults
              break
            case 'OVER_QUERY_LIMIT':
              errorMessage = errors.addressQueryLimit
              break
            case 'REQUEST_DENIED':
              errorMessage = errors.authError
              break
            default:
              errorMessage = errors.addressError
              break
          }

          // Show errors only to merchant in the editor.
          if (Shopify.designMode) {
            $map
              .parent()
              .addClass(classes.mapError)
              .html(
                '<div class="' +
                  classes.errorMsg +
                  '">' +
                  errorMessage +
                  '</div>'
              )
          }
        })
    },

    onUnload: function() {
      if (this.$map.length === 0) {
        return
      }
      google.maps.event.clearListeners(this.map, 'resize')
    },
  })

  return Map
})()

/* eslint-disable no-new */
theme.Product = (function() {
  function Product(container) {
    var $container = (this.$container = $(container))
    var sectionId = $container.attr('data-section-id')
    this.$timeDisplay = $container.find('.js-countdown')
    this.interval = undefined

    this.settings = {
      // Breakpoints from src/stylesheets/global/variables.scss.liquid
      mediaQueryMediumUp: 'screen and (min-width: 750px)',
      mediaQuerySmall: 'screen and (max-width: 749px)',
      bpSmall: false,
      enableHistoryState: $container.data('enable-history-state') || false,
      namespace: '.slideshow-' + sectionId,
      sectionId: sectionId,
      sliderActive: false,
      zoomEnabled: false,
    }

    this.selectors = {
      addToCart: '#AddToCart-' + sectionId,
      addToCartText: '#AddToCartText-' + sectionId,
      comparePrice: '#ComparePrice-' + sectionId,
      originalPrice: '#ProductPrice-' + sectionId,
      SKU: '.variant-sku',
      variant: '.product-single__variant-' + sectionId,
      originalPriceWrapper: '.product-price__price-' + sectionId,
      originalSelectorId: '#ProductSelect-' + sectionId,
      productImageWraps: '.product-single__photo',
      productPrices: '.product-single__price-' + sectionId,
      productThumbImages: '.product-single__thumbnail--' + sectionId,
      productThumbs: '.product-single__thumbnails-' + sectionId,
      saleClasses: 'product-price__sale product-price__sale--single',
      saleLabel: '.product-price__sale-label-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId,
      shopifyPaymentButton: '.shopify-payment-button',
      form: 'form[action^="/cart/add"]',
      slider: '#pp-slider',
      productVideo: '#product-video',
    }

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$('#ProductJson-' + sectionId).html()) {
      return
    }

    this.productSingleObject = JSON.parse(
      document.getElementById('ProductJson-' + sectionId).innerHTML
    )

    this.settings.zoomEnabled = $(this.selectors.productImageWraps).hasClass(
      'js-zoom-enabled'
    )

    this._setForm()
    this._initBreakpoints()
    this._stringOverrides()
    this._initVariants()
    this._initImageSwitch()
    this._setActiveThumbnail()
    this._initAccordions()
    this._initSticky()

    if (this.$timeDisplay.length) {
      this._initReleaseTimer()
    }

    if ($(this.selectors.productVideo).length) {
      this._initVideoHandler()
    }
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    _initVideoHandler: function() {
      var self = this
      this.video = document.querySelector(this.selectors.productVideo)

      function computeWaypoint(el, offset) {
        el = $(el).get(0)
        offset = offset || 0
        var rect = el.getBoundingClientRect()
        var wHeight = window.innerHeight

        var isVisible = rect.top >= 0 && rect.bottom <= wHeight + offset

        var location = 'INSIDE'
        if (rect.bottom >= wHeight + offset) {
          location = 'BOTTOM'
        }

        if (rect.top <= 0) {
          location = 'TOP'
        }

        return {
          isVisible: isVisible,
          location: location,
        }
      }

      function setVideoPlayStatus() {
        var waypoint = computeWaypoint(self.video)

        if (waypoint.isVisible && !self.video.isPlaying) {
          return self.video.play()
        }

        if (!waypoint.isVisible && self.video.isPlaying) {
          return self.video.pause()
        }
      }

      function handlePlayVideo() {
        $(this).remove()
        self.video.play()
      }

      $(window).on(
        'DOMContentLoaded load resize resize scroll touchmove',
        setVideoPlayStatus
      )

      if (!mobileCheck()) {
        $(self.video).parent().find('.js-video-play').remove()
      } else {
        $('.js-video-play').on('click', handlePlayVideo)
      }
    },

    _initReleaseTimer: function() {
      var self = this
      this.timer = new theme.Countdown(this.$container, true)
      this.worker = this.timer.workers[0]

      var relativeDt = this.worker.getRelativeDt()
      if (relativeDt.diffEnd > 0) {
        this.$form = $(this.selectors.form).detach()
        this.$timeDisplay.show()
        this.interval = window.setInterval(self._renderDt.bind(self), 1000)
        this._renderDt()
      }
    },

    _renderDt: function() {
      var relativeDt = this.worker.getRelativeDt()

      if (relativeDt.diffEnd <= 0) {
        window.clearInterval(interval)
        this.$timeDisplay.hide()
        $('#form-gate').appendChild(this.$form)
        return null
      }

      var days = theme.Countdown.pad(relativeDt.DD)
      var hours = theme.Countdown.pad(relativeDt.HH)
      var minutes = theme.Countdown.pad(relativeDt.mm)
      var seconds = theme.Countdown.pad(relativeDt.ss)
      $('#days').text(days)
      $('#hours').text(hours)
      $('#minutes').text(minutes)
      $('#seconds').text(seconds)
    },

    _initAccordions: function() {
      this.accordions = new theme.Accordions(this.$container)
      this.$container.on('melanie.slide', this._calcStick.bind(this))
    },

    _calcStick: function() {
      if (this.sticky instanceof theme.Sticker) {
        this.sticky.setState()
        this.sticky.setPosition()
      }
    },

    _initSticky: function() {
      var self = this
      var $slider = $(this.selectors.slider)

      function watch(element) {
        if (window.MutationObserver) {
          var config = {
            attributes: true,
          }

          var stickyObserver = new MutationObserver(self._calcStick.bind(self))
          stickyObserver.observe(element, config)
        }
      }

      function registerSticker() {
        function triggerVideo($slide, method) {
          if (!mobileCheck() && $slide.find('#product-video').length) {
            var video = $slide.find('video')[0]
            if (video.readyState === 4) {
              $slide.find('video')[0][method]()
            }
          }
        }

        self.sticky = new theme.Sticker({
          waypoint: '#waypoint',
          stickElement: '.js-sticky',
          scrollOffset: function() {
            return (
              $('#site-header').innerHeight() +
              $('.breadcrumb').outerHeight(true)
            )
          },
        })

        $slider.on('init', function(e, slick) {
          triggerVideo($(slick.$slides[0]), 'play')
        })

        $slider.on('afterChange', function(e, slick, currentSlide) {
          triggerVideo($(slick.$slides[currentSlide]), 'play')
        })

        $slider.on('beforeChange', function(e, slick, currentSlide, nextSlide) {
          triggerVideo($(slick.$slides[currentSlide]), 'pause')
        })

        enquire.register(self.settings.mediaQueryMediumUp, {
          match: function() {
            self.sticky.stick()
            if ($slider.hasClass('slick-initialized')) {
              $slider.slick('unslick')
            }
          },
        })

        enquire.register(self.settings.mediaQuerySmall, {
          match: function() {
            self.sticky.unstick()
            if (!$slider.hasClass('slick-initialized')) {
              $slider.slick({ arrows: false, dots: true })
            }
          },
        })
      }

      var $stickyElement = $('.js-sticky')
      var $waypoint = $('#waypoint')
      if ($stickyElement.length && $waypoint.length) {
        registerSticker()
        watch($stickyElement[0])
      }
    },

    _setForm: function() {
      $(this.$container)
        .find(this.selectors.form)
        .attr('data-cart-submit', true)
    },

    _stringOverrides: function() {
      theme.productStrings = theme.productStrings || {}
      $.extend(theme.strings, theme.productStrings)
    },

    _initBreakpoints: function() {
      var self = this

      enquire.register(this.settings.mediaQuerySmall, {
        match: function() {
          // initialize thumbnail slider on mobile if more than three thumbnails
          if ($(self.selectors.productThumbImages).length > 3) {
            self._initThumbnailSlider()
          }

          // destroy image zooming if enabled
          if (self.settings.zoomEnabled) {
            $(self.selectors.productImageWraps).each(function() {
              _destroyZoom(this)
            })
          }

          self.settings.bpSmall = true
        },
        unmatch: function() {
          if (self.settings.sliderActive) {
            self._destroyThumbnailSlider()
          }

          self.settings.bpSmall = false
        },
      })

      enquire.register(this.settings.mediaQueryMediumUp, {
        match: function() {
          if (self.settings.zoomEnabled) {
            $(self.selectors.productImageWraps).each(function() {
              _enableZoom(this)
            })
          }
        },
      })
    },

    _initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState:
          this.$container.data('enable-history-state') || false,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject,
      }

      this.variants = new slate.Variants(options)

      this.$container.on(
        'variantChange' + this.settings.namespace,
        this._updateAddToCart.bind(this)
      )
      this.$container.on(
        'variantImageChange' + this.settings.namespace,
        this._updateImages.bind(this)
      )
      this.$container.on(
        'variantPriceChange' + this.settings.namespace,
        this._updatePrice.bind(this)
      )
      this.$container.on(
        'variantSKUChange' + this.settings.namespace,
        this._updateSKU.bind(this)
      )
    },

    _initImageSwitch: function() {
      if (!$(this.selectors.productThumbImages).length) {
        return
      }

      var self = this

      $(this.selectors.productThumbImages).on('click', function(evt) {
        evt.preventDefault()
        var $el = $(this)

        var imageId = $el.data('thumbnail-id')

        self._switchImage(imageId)
        self._setActiveThumbnail(imageId)
      })
    },

    _setActiveThumbnail: function(imageId) {
      var activeClass = 'active-thumb'

      // If there is no element passed, find it by the current product image
      if (typeof imageId === 'undefined') {
        imageId = $(this.selectors.productImageWraps + ":not('.hide')").data(
          'image-id'
        )
      }

      var $thumbnail = $(
        this.selectors.productThumbImages +
          "[data-thumbnail-id='" +
          imageId +
          "']"
      )
      $(this.selectors.productThumbImages).removeClass(activeClass)
      $thumbnail.addClass(activeClass)
    },

    _switchImage: function(imageId) {
      var $newImage = $(
        this.selectors.productImageWraps + "[data-image-id='" + imageId + "']",
        this.$container
      )
      var $otherImages = $(
        this.selectors.productImageWraps +
          ":not([data-image-id='" +
          imageId +
          "'])",
        this.$container
      )
      $newImage.removeClass('hide')
      $otherImages.addClass('hide')
    },

    _initThumbnailSlider: function() {
      var options = {
        slidesToShow: 4,
        slidesToScroll: 3,
        infinite: false,
        prevArrow: '.thumbnails-slider__prev--' + this.settings.sectionId,
        nextArrow: '.thumbnails-slider__next--' + this.settings.sectionId,
        responsive: [
          {
            breakpoint: 321,
            settings: {
              slidesToShow: 3,
            },
          },
        ],
      }

      $(this.selectors.productThumbs).slick(options)
      this.settings.sliderActive = true
    },

    _destroyThumbnailSlider: function() {
      $(this.selectors.productThumbs).slick('unslick')
      this.settings.sliderActive = false
    },

    _updateAddToCart: function(evt) {
      var variant = evt.variant

      if (variant) {
        $(this.selectors.productPrices)
          .removeClass('visibility-hidden')
          .attr('aria-hidden', 'true')

        if (variant.available) {
          $(this.selectors.addToCart).prop('disabled', false)
          $(this.selectors.addToCartText).text(theme.strings.addToCart)
          $(this.selectors.shopifyPaymentButton, this.$container).show()
        } else {
          // The variant doesn't exist, disable submit button and change the text.
          // This may be an error or notice that a specific variant is not available.
          $(this.selectors.addToCart).prop('disabled', true)
          $(this.selectors.addToCartText).text(theme.strings.soldOut)
          $(this.selectors.shopifyPaymentButton, this.$container).hide()
        }

        $(this.selectors.variant).html(variant.title)
      
        const newurl =
          window.location.protocol +
          "//" +
          window.location.host +
          window.location.pathname +
          "?variant=" +
          variant.id;

        window.history.replaceState({ path: newurl }, "", newurl);
      } else {
        $(this.selectors.addToCart).prop('disabled', true)
        $(this.selectors.addToCartText).text(theme.strings.unavailable)
        $(this.selectors.productPrices)
          .addClass('visibility-hidden')
          .attr('aria-hidden', 'false')
        $(this.selectors.shopifyPaymentButton, this.$container).hide()
      }
    },

    _updateImages: function(evt) {
      var variant = evt.variant
      var imageId = variant.featured_image.id

      this._switchImage(imageId)
      this._setActiveThumbnail(imageId)
    },

    _updatePrice: function(evt) {
      var variant = evt.variant

      // Update the product price
      $(this.selectors.originalPrice).html(
        theme.Currency.formatMoney(variant.price, theme.moneyFormat)
      )

      // Update and show the product's compare price if necessary
      if (variant.compare_at_price > variant.price) {
        $(this.selectors.comparePrice)
          .html(
            theme.Currency.formatMoney(
              variant.compare_at_price,
              theme.moneyFormat
            )
          )
          .removeClass('hide')

        $(this.selectors.originalPriceWrapper).addClass(
          this.selectors.saleClasses
        )

        $(this.selectors.saleLabel).removeClass('hide')
      } else {
        $(this.selectors.comparePrice).addClass('hide')
        $(this.selectors.saleLabel).addClass('hide')
        $(this.selectors.originalPriceWrapper).removeClass(
          this.selectors.saleClasses
        )
      }
    },

    _updateSKU: function(evt) {
      var variant = evt.variant

      // Update the sku
      $(this.selectors.SKU).html(variant.sku)
    },

    onUnload: function() {
      this.$container.off(this.settings.namespace)
    },
  })

  function _enableZoom(el) {
    var zoomUrl = $(el).data('zoom')
    $(el).zoom({
      url: zoomUrl,
    })
  }

  function _destroyZoom(el) {
    $(el).trigger('zoom.destroy')
  }

  return Product
})()

theme.Quotes = (function() {
  var config = {
    mediaQuerySmall: 'screen and (max-width: 749px)',
    mediaQueryMediumUp: 'screen and (min-width: 750px)',
    slideCount: 0,
  }
  var defaults = {
    accessibility: true,
    arrows: false,
    dots: true,
    autoplay: false,
    touchThreshold: 20,
    slidesToShow: 3,
    slidesToScroll: 3,
  }

  function Quotes(container) {
    var $container = (this.$container = $(container))
    var sectionId = $container.attr('data-section-id')
    var wrapper = (this.wrapper = '.quotes-wrapper')
    var slider = (this.slider = '#Quotes-' + sectionId)
    var $slider = $(slider, wrapper)

    var sliderActive = false
    var mobileOptions = $.extend({}, defaults, {
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
    })

    config.slideCount = $slider.data('count')

    // Override slidesToShow/Scroll if there are not enough blocks
    if (config.slideCount < defaults.slidesToShow) {
      defaults.slidesToShow = config.slideCount
      defaults.slidesToScroll = config.slideCount
    }

    $slider.on('init', this.a11y.bind(this))

    enquire.register(config.mediaQuerySmall, {
      match: function() {
        initSlider($slider, mobileOptions)
      },
    })

    enquire.register(config.mediaQueryMediumUp, {
      match: function() {
        initSlider($slider, defaults)
      },
    })

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        sliderObj.slick('unslick')
        sliderActive = false
      }

      sliderObj.slick(args)
      sliderActive = true
    }
  }

  Quotes.prototype = _.assignIn({}, Quotes.prototype, {
    onUnload: function() {
      enquire.unregister(config.mediaQuerySmall)
      enquire.unregister(config.mediaQueryMediumUp)

      $(this.slider, this.wrapper).slick('unslick')
    },

    onBlockSelect: function(evt) {
      // Ignore the cloned version
      var $slide = $(
        '.quotes-slide--' + evt.detail.blockId + ':not(.slick-cloned)'
      )
      var slideIndex = $slide.data('slick-index')

      // Go to selected slide, pause autoplay
      $(this.slider, this.wrapper).slick('slickGoTo', slideIndex)
    },

    a11y: function(event, obj) {
      var $list = obj.$list
      var $wrapper = $(this.wrapper, this.$container)

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live')

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite')
        }
      })

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live')
        }
      })
    },
  })

  return Quotes
})()

theme.slideshows = {}

theme.SlideshowSection = (function() {
  function SlideshowSection(container) {
    var $container = (this.$container = $(container))
    var sectionId = $container.attr('data-section-id')
    var slideshow = (this.slideshow = '#Slideshow-' + sectionId)

    $('.slideshow__video', slideshow).each(function() {
      var $el = $(this)
      theme.SlideshowVideo.init($el)
      theme.SlideshowVideo.loadVideo($el.attr('id'))
    })

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow)
  }

  return SlideshowSection
})()

theme.SlideshowSection.prototype = _.assignIn(
  {},
  theme.SlideshowSection.prototype,
  {
    onUnload: function() {
      delete theme.slideshows[this.slideshow]
    },

    onBlockSelect: function(evt) {
      var $slideshow = $(this.slideshow)

      // Ignore the cloned version
      var $slide = $(
        '.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)'
      )
      var slideIndex = $slide.data('slick-index')

      // Go to selected slide, pause autoplay
      $slideshow.slick('slickGoTo', slideIndex).slick('slickPause')
    },

    onBlockDeselect: function() {
      // Resume autoplay
      $(this.slideshow).slick('slickPlay')
    },
  }
)

theme.CountdownSection = (function() {
  function CountdownSection(container) {
    this.countdown = new theme.Countdown(container)
    this.mobileSlider = new theme.MobileSlider(container)
  }

  return CountdownSection
})()

theme.Launch = (function() {
  function Launch(container) {
    this.countdown = new theme.Countdown(container)
  }

  return Launch
})()

theme.CollectionSection = (function() {
  function CollectionSection(container) {
    this.mobileSlider = new theme.MobileSlider(container)
  }

  return CollectionSection
})()

theme.FeatureRowSection = (function() {
  function FeatureRowSection(container) {
    // this.mobileSlider = new theme.MobileSlider(container)
  }

  return FeatureRowSection
})()

theme.ImageBar = (function () {
  function ImageBar(container) {
    this.mobileSlider = new theme.MobileSlider(container)
  }

  return ImageBar
})()

theme.InstagramSection = (function() {
  function InstagramSection(container) {
    this.$container = $(container)
    this.sectionId = this.$container.attr('data-section-id')
    this.token = this.$container.attr('data-token')
    this.uid = this.$container.attr('data-uid')
    this.template = this.$container.attr('data-template')
    this.shopifySelector = '#shopify-section-' + this.sectionId
    this.init()
  }

  InstagramSection.prototype.init = function() {
    var self = this
    try {
      new Instafeed({
        get: 'user',
        link: 'true',
        limit: 12,
        resolution: 'standard_resolution',
        accessToken: self.token,
        template: self.template,
        get: 'user',
        userId: 'self',
        filter: $.proxy(self.applyFilter),
      }).run()
      this.mobileSlider = new theme.MobileSlider(this.$container)
    } catch (error) {
      window.catchErrors(self.destroy)(error)
    }
  }

  // No clue what this does
  InstagramSection.prototype.applyFilter = function(image) {
    var date = new Date(image.created_time * 1000)

    m = date.getMonth()
    d = date.getDate()
    y = date.getFullYear()

    var monthNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ]

    image.created_time = monthNames[m] + ' ' + d + ', ' + y

    return true
  }

  InstagramSection.prototype.destroy = function() {
    $(this.shopifySelector).remove()
  }

  return InstagramSection
})()

$(document).ready(function() {
  var sections = new theme.Sections()

  sections.register('cart-template', theme.Cart)
  sections.register('product', theme.Product)
  sections.register('collection-template', theme.Filters)
  sections.register('product-template', theme.Product)
  sections.register('header-section', theme.HeaderSection)
  sections.register('map', theme.Maps)
  sections.register('slideshow-section', theme.SlideshowSection)
  sections.register('quotes', theme.Quotes)
  sections.register('launch-template', theme.Launch)
  sections.register('countdown-section', theme.CountdownSection)
  sections.register('collection-section', theme.CollectionSection)
  sections.register('feature-row-product-section', theme.FeatureRowSection)
  sections.register('instagram-section', theme.InstagramSection)
  sections.register('swiper-section', theme.SwiperSection)
  sections.register('image-bar', theme.ImageBar)
})

theme.init = function() {
  theme.customerTemplates.init()

  // Theme-specific selectors to make tables scrollable
  var tableSelectors = '.rte table,' + '.custom__item-inner--html table'

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'scrollable-wrapper',
  })

  // Theme-specific selectors to make iframes responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"],' +
    '.custom__item-inner--html iframe[src*="youtube.com/embed"],' +
    '.custom__item-inner--html iframe[src*="player.vimeo"]'

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'video-wrapper',
  })

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash))

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash))
  })

  $('a[href="#"]').on('click', function(evt) {
    evt.preventDefault()
  })
}

theme.others = function() {
  var searchtimeout
  function openSearch(e) {
    e.preventDefault()
    var $this = $(this)

    window.setTimeout(function() {
      $('.search-header__input.search__input').focus()
    }, 250)

    $('.js-openthemainsearchbarparent').addClass(
      'site-nav__item--search-bar-has-expanded'
    )
    window.clearTimeout(searchtimeout)
    searchtimeout = window.setTimeout(function() {
      $('.js-openthemainsearchbarparent').removeClass('o-hidden')
    }, 100)
  }

  function closeSearch() {
    $('.search-header__input.search__input')
      .focus()
      .blur()
    $('.js-openthemainsearchbarparent')
      .removeClass('site-nav__item--search-bar-has-expanded')
      .find('.autocomplete__spinner')
      .removeClass('header__item-search--active')

    window.clearTimeout(searchtimeout)
    searchtimeout = window.setTimeout(function() {
      $('.js-openthemainsearchbarparent').addClass('o-hidden')
    }, 100)
  }

  $('.js-letsopenthemainsearchbar').on('click', openSearch)
  $('.js-letsclosethemainsearchbar').on('click', closeSearch)
  $('.js-openthemainsearchbarparent')
    .on('keyup.search', function(e) {
      if (e.keyCode === 27) closeSearch()
    })
    .on('click', function(e) {
      e.stopPropagation()
    })

  // $(document).click(closeSearch);

  $('.js-quick-shop-btn').each(function() {
    var selector = $(this).attr('data-form')
    var options = {
      $container: $('#' + selector),
      singleOptionSelector: '.single-option-selector-' + selector,
      product: JSON.parse(
        ($('#ProductJson-' + selector)[0] || {}).innerHTML || '{}'
      ),
      originalSelectorId: '#ProductSelect-' + selector,
    }
    var $btn = options.$container.find('.js-quick-shop-btn')
    var $close = options.$container.find('.js-quick-shop-close')
    var $shop = options.$container.find('.quick-shop')
    var $variableOptions = options.$container.find('.js-variable-option').find('option')
    var $variableSelect = options.$container.find('.js-variable-option').find('select')
    
    var variants = new slate.Variants(options)
    var selectIndex = $variableSelect.attr('data-i')
    var quantity = variants.product.variants.reduce(function (acc, cur) {
      var key = cur.options[selectIndex]
      acc[key] = cur.inventory_quantity
      return acc
    }, {})

    var classname = 'quick-shop--form-active'

    $variableOptions.each(function () {
      var key = $(this).val()
      var item = quantity[key]
      if (item === 0) {
        $(this).text($(this).text() + ' (SOLD OUT)')
        $(this).prop('disabled', true)
      } else if(item === 1) {
        $(this).text($(this).text() + ' (ONLY 1 LEFT)')
      }
    })

    function trap() {
      slate.a11y.trapFocus({
        $container: options.$container,
        namespace: 'shop_focus',
      })
    }

    function untrap() {
      slate.a11y.removeTrapFocus({
        $container: options.$container,
        namespace: 'shop_focus',
      })
    }

    function open() {
      $shop.addClass(classname)
      trap()
      return false
    }

    function close() {
      $shop.removeClass(classname)
      untrap()
      return false
    }

    function listenForEsc(e) {
      return e.keyCode === 27 && close()
    }

    function handlemouseleave() {
      return $shop.hasClass(classname) && untrap()
    }

    function handlemouseenter() {
      return $shop.hasClass(classname) && trap()
    }

    $btn.on('click.shop', open)
    $close.on('click.shop', close)
    options.$container
      .on('keyup.shop', listenForEsc)
      .on('mouseleave.shop', handlemouseleave)
      .on('mouseenter.shop', handlemouseenter)
  })

  ;(function(shouldInit) {
    if (!shouldInit) return null

    Currency.format = theme.currency.format
    var shopCurrency = theme.currency.shop

    /* Sometimes merchants change their shop currency, let's tell our JavaScript file */
    Currency.moneyFormats[shopCurrency].money_with_currency_format =
      theme.moneyWithCurrencyFormat
    Currency.moneyFormats[shopCurrency].money_format = theme.moneyFormat

    /* Default currency */
    var defaultCurrency = theme.currency.initial

    /* Cookie currency */
    var cookieCurrency = Currency.cookie.read()

    /* Fix for customer account pages */
    jQuery('span.money span.money').each(function() {
      jQuery(this)
        .parents('span.money')
        .removeClass('money')
    })

    /* Saving the current price */
    jQuery('span.money').each(function() {
      jQuery(this).attr(
        'data-currency-' + theme.currency.shop,
        jQuery(this).html()
      )
    })

    // If there's no cookie.
    if (cookieCurrency == null) {
      if (shopCurrency !== defaultCurrency) {
        Currency.convertAll(shopCurrency, defaultCurrency)
      } else {
        Currency.currentCurrency = defaultCurrency
      }
    }
    // If the cookie value does not correspond to any value in the currency dropdown.
    else if (
      jQuery('[name=currencies]').size() &&
      jQuery(
        '[name=currencies] option[value=' + cookieCurrency + ']'
      ).size() === 0
    ) {
      Currency.currentCurrency = shopCurrency
      Currency.cookie.write(shopCurrency)
    } else if (cookieCurrency === shopCurrency) {
      Currency.currentCurrency = shopCurrency
    } else {
      Currency.convertAll(shopCurrency, cookieCurrency)
    }

    jQuery('[name=currencies]')
      .val(Currency.currentCurrency)
      .change(function() {
        var newCurrency = jQuery(this).val()
        Currency.convertAll(Currency.currentCurrency, newCurrency)
        jQuery('.selected-currency').text(Currency.currentCurrency)
      })

    var original_selectCallback = window.selectCallback
    var selectCallback = function(variant, selector) {
      original_selectCallback(variant, selector)
      Currency.convertAll(shopCurrency, jQuery('[name=currencies]').val())
      jQuery('.selected-currency').text(Currency.currentCurrency)
    }

    $('body').on('ajaxCart.afterCartLoad', function(cart) {
      Currency.convertAll(shopCurrency, jQuery('[name=currencies]').val())
      jQuery('.selected-currency').text(Currency.currentCurrency)
    })

    jQuery('.selected-currency').text(Currency.currentCurrency)
  })(theme.currency.showMultiple)
}

theme.awesomecomplete = (function() {
  // STOLEN FROM PREVIOUS THEME
  /**
   * Plugin to handle auto-completion
   */

  function init() {
    var methods = {
      /**
       * Init the plugin
       */
      init: function() {
        var element = $(this)

        // On IE8 there is no auto-completion and we just redirect to the search page
        if ($('html').hasClass('ie8')) {
          return
        }

        if (theme.features.autocompletionEnabled) {
          element.find('.search-header__input').awesomecomplete({
            resultLimit: 50,
            typingDelay: 50,
            suggestionListClass: 'autocomplete__results',
            itemClass: 'autocomplete__result',
            activeItemClass: 'autocomplete__result--active',
            splitTerm: false,
            attachTo: $('.autocomplete'),
            wrapSuggestions: true,
            highlightMatches: false,

            dataMethod: function(term, event, done) {
              element
                .find('.autocomplete__spinner')
                .addClass('header__item-search--active')

              var searchData = {
                q: term + '*',
                view: 'auto-complete',
              }

              if (theme.features.searchMode === 'products') {
                searchData['type'] = 'product'
              }

              $.ajax({
                url: '/search',
                dataType: 'json',
                data: searchData,
              }).then(function(data) {
                return done(data)
              })
            },

            sortFunction: function(result) {
              return 0
            },

            renderFunction: function(result, term) {
              element
                .find('.autocomplete__spinner')
                .removeClass('header__item-search--active')
              if (result['results_count'] !== undefined) {
                if (result['results_count'] === 0) {
                  return (
                    '<p class="autocomplete__no-results">' +
                    theme.autocomplete.noResults +
                    '</p>'
                  )
                } else {
                  return (
                    '<a href="' +
                    result['url'] +
                    '" class="btn autocomplete__btn">' +
                    theme.autocomplete.seeAll +
                    ' (' +
                    result['results_count'] +
                    ')</a>'
                  )
                }
              } else {
                var html =
                  '<div class="autocomplete__item autocomplete__item--image one-third">' +
                  '<img src="' +
                  result['image'] +
                  '" class="autocomplete__image">' +
                  '</div>' +
                  '<div class="autocomplete__item autocomplete__item--info two-thirds">' +
                  (result['price_min'] === null
                    ? 'autocomplete__info--page'
                    : '')

                if (result['vendor']) {
                  html +=
                    '<span class="autocomplete__brand"><strong>' +
                    result['vendor'] +
                    '</strong></span>'
                }

                html +=
                  '<span class="autocomplete__title">' +
                  result['title'] +
                  '</span>'

                if (result['object_type'] === 'product') {
                  var priceMin = result['price_min'],
                    priceMin = theme.Currency.formatMoney(
                      priceMin,
                      theme.moneyFormat
                    )
                  html +=
                    '<span class="autocomplete__price">' + priceMin + '</span>'
                }

                html += '</div>'
                return html
              }
            },

            onComplete: function(dataItem) {
              console.log('We have completed ', dataItem)
              location.href = dataItem['url']
            },
          })
        }
      },
    }

    $.fn.searchAutocomplete = function(options) {
      return methods.init.call(this, options)
    }

    $('.js-openthemainsearchbarparent').searchAutocomplete()
  }

  return { init: init }
})()

$(function() {
  theme.init()
  theme.others()
  theme.awesomecomplete.init()
})

/* $(document).ready(function() {
  $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
    if ($('#agree').is(':checked')) {
      $(this).submit();
    }
    else {
      alert("You must agree with the terms and conditions of sales to check out.");
      return false;
    }
  });
}); */